<template>
  <div class="canvas">
    <div v-if="tab == 'Patient'" class="searchfindarea d-none d-lg-block">
      <!-- This is the top level banner, holds the share + add patient + total orders features -->
      <!--Modalfor Order Adjustment-->
      <Teleport to="body">
        <div
          v-if="orderquestionmodal"
          class="orderquestmodal-overlay eh-popup-overlay"
          @click.self="closeOrdQModal"
        >
          <div
            class="orderquestmodal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="ordq-dialog-title"
          >
            <div class="ordqmodaltitlebar">
              <h1 id="ordq-dialog-title">Patient Order Options</h1>
              <button
                type="button"
                class="ordq-close"
                title="Close Order Modal"
                aria-label="Close"
                @click="closeOrdQModal()"
              >
                X
              </button>
            </div>
            <div class="ordqmodalbody">
              <p>Would you like to view orders or create a new order?</p>
              <p>
                <a @click="showPendingOrderModal()"> View Pending Orders</a>
              </p>
              <p>
                <a @click="modalShowOrderPopup()" title="Create New Order">New Order</a>
              </p>
            </div>
          </div>
        </div>
      </Teleport>
      <!--OrderPendingGrid-->
      <Teleport to="body">
      <div
        v-if="ispendingordermodal"
        class="ordgridmodal-overlay eh-popup-overlay"
        @click.self="closePendingOrderModal"
      >
        <div
          class="ordgridmodal eh-popup-panel"
          @dragstart="startDrag"
        >
        <div class="ordgridtitlebar">
          <span class="ordgridtitlebar-spacer" aria-hidden="true"></span>
          <h1 class="ordgridtitle">Pending Orders</h1>
          <button
            type="button"
            class="ordgrid-close"
            title="Close Order Grid"
            aria-label="Close"
            @click="closePendingOrderModal()"
          >
            ✕
          </button>
        </div>
        <div class="gridarea">
          <div class="container">
            <div class="columntop d-none d-lg-flex pending-orders-header">
              <div class="pending-col">
                <span id="col1" class="coltext">Patient</span>
              </div>
              <div class="pending-col pending-col-medproc">
                <span id="col2" class="coltext">Medication / Procedure</span>
              </div>
              <div class="pending-col">
                <span id="col4" class="coltext">Order Date</span>
              </div>
              <div class="pending-col">
                <span id="col4" class="coltext">Order Time</span>
              </div>
              <div class="pending-col">
                <span id="col6" class="coltext">Order Type</span>
              </div>
              <div class="pending-col">
                <span id="col7" class="coltext">Status</span>
              </div>
              <div class="pending-col">
                <span id="col8" class="coltext">Nurse Signature</span>
              </div>
              <div class="pending-col">
                <span id="col8" class="coltext">Provider Signature</span>
              </div>
            </div>
            <div class="ordpendingridbody">
              <div
                class="columnrow columnrowmb pending-orders-row"
                v-for="(ord, index) in pendingorders"
                :key="'pendingOrder' + index"
              >
                <div class="pending-col top-row">
                  <span
                    id="ordPatientName"
                    class="coltext"
                    >{{ ord.pending_order_patient_name || '-' }}</span
                  >
                </div>
                <div class="pending-col top-row pending-col-medproc">
                  <span
                    id="ordMedProc"
                    class="coltext msgiconbtn"
                    :title="pendingOrderMedProcLabel(ord)"
                    >{{ pendingOrderMedProcLabel(ord) }}</span
                  >
                </div>
                <div class="pending-col top-row">
                  <span id="ordWriter" class="coltext msgiconbtn">
                    {{ ord.orderdate}}
                  </span>
                </div>
                <div class="pending-col top-row">
                  <span id="ordDate" class="coltext msgiconbtn">
                    {{ ord.ordertime }}
                  </span>
                </div>
                <div class="pending-col top-row">
                  <span id="ordType" class="coltext msgiconbtn">
                    {{ ord.ordertype }}
                  </span>
                </div>
                <div class="pending-col top-row">
                  <span id="ordStatus" class="coltext msgiconbtn">
                    {{ ord.status }}
                  </span>
                </div>
                <div class="pending-col top-row pending-col-signature">
                  <button
                    v-if="pendingOrderSignatureBlank(ord.nursesignature)"
                    type="button"
                    class="pending-sign-btn"
                    @click="showPendingOrder(ord, ord.patientid)"
                  >
                    Sign
                  </button>
                  <span v-else id="ordSig" class="coltext">{{
                    ord.nursesignature
                  }}</span>
                </div>
                <div class="pending-col top-row pending-col-signature">
                  <button
                    v-if="pendingOrderSignatureBlank(ord.providersignature)"
                    type="button"
                    class="pending-sign-btn"
                    @click="showPendingOrder(ord, ord.patientid)"
                  >
                    Sign
                  </button>
                  <span v-else id="ordNursSigDate" class="coltext">{{
                    ord.providersignature
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      </Teleport>
      <!--endOrderPEndingGrid-->

      <div class="container">
        <order-widget
          :owner-unique-id="actorUniqueId"
          :proflicense="this.allData.patient.npi"
          :accounttype="this.accounttype"
          :accountNum="this.allData.patient.externId2"
          @custom-event="RetrieveOrder"
          ><h1>Here</h1></order-widget
        >
        <!-- Pending order popup for orders in the OrderWidget, since they cannot be in
         patient grid rows  -->
        <pendingorder-popup
          v-if="tab == 'Patient' && orderWidgetDetailOpen"
          class="pendingorder_popup"
          ref="pndordpopWidget"
          :orderNum="orderNum"
          :patient="orderWidgetPopupPatient"
          :id="'pendingorder_popup_widget'"
          :order="pendingordData"
          :pendingDetails="pendingDetails"
          :prov="provData"
          @childGetAccountPendingOrdersByPatID="handleOrderWidgetPopupClose"
        />
        <div class="iconfield col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        </div>
        <div class="iconfield col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!-- Add Users lives under Administration — not duplicated on HomeGrid -->
        </div>
        <!-- Hidden outright rather than shown empty: a blank count next to
             "Pending Orders:" reads as zero, and for a user without
             `orders:read` the count is unknown, not zero. -->
        <div v-if="canOrderView" class="iconfield col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <p>
            <b>{{ ordType }} Orders:</b>
            <span id="pdorders" @click="showAllPendingOrderModal">{{
              numberofPendingOrder
            }}</span>
          </p>
        </div>
        <div class="filter-icon col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
          <button @click="orderWidgetDisplay($event)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="white"
            >
              <rect x="0" y="0" width="24" height="24" fill="black" />
              <path d="M10 18h4v-2h-4v2zm-7-8v2h14v-2H3zm3-6v2h8V4H6z" />
            </svg>
          </button>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 addNurseSec">
        <add-user-form v-if="showingAddUser" @close="CloseaddNurse" />
      </div>
    </div>
    <div class="gridarea">
      <!-- The actual grid information, including list of accounts and pagination -->
      <div v-if="gridListPage" class="mobile-form-list">
        <!-- Column headers for diplays that are specifically large or bigger -->
        <div class="columntop d-none d-lg-flex">
          <template v-if="tab == 'Patient'">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col id-col">
              <span id="col1" class="coltext">ID</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col2" class="coltext">Name</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-1 col-lg-1 col-xl-1 top-col">
              <span id="col2" class="coltext">Date of Birth</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3" class="coltext">Phone Number</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col4" class="coltext">Assignment Date</span>
            </div>
            <!--<div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col6" class="coltext">Remote</span>
            </div>-->
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7" class="coltext">Communication</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-1 col-lg-1 col-xl-1 top-col">
              <span id="col8" class="coltext">Status</span>
            </div>
          </template>
          <template v-if="tab == 'Provider'">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col1" class="coltext">ID</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-col">
              <span id="col2" class="coltext">Name</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3" class="coltext">NPI</span>
            </div>
            <!-- Assignments column (stethoscope) temporarily hidden
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col4" class="coltext">Assignments</span>
            </div>
            -->
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col5" class="coltext">Communications</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col6" class="coltext">Status</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7" class="coltext">Email</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col8" class="coltext">Phone Number</span>
            </div>
          </template>
          <template v-if="isNurseColumnTab">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-col">
              <span id="col2" class="coltext">Name</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3" class="coltext">License Number</span>
            </div>
            <!-- Assignments column (stethoscope) temporarily hidden
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col4" class="coltext">Assignments</span>
            </div>
            -->
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col5" class="coltext">Communications</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col6" class="coltext">Status</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7" class="coltext">License Expiry</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7" class="coltext">Insurance Expiry</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col8" class="coltext">Phone Number</span>
            </div>
          </template>
          <template v-if="isAidColumnTab">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-col">
              <span id="col2" class="coltext">Name</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3" class="coltext">Username</span>
            </div>
            <!-- Assignments column (stethoscope) temporarily hidden
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col4" class="coltext">Assignments</span>
            </div>
            -->
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col5" class="coltext">Communications</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col6" class="coltext">Status</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7" class="coltext">Has Certificate</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7" class="coltext">Certificate Number</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-col">
              <span id="col8" class="coltext">Account Status</span>
            </div>
          </template>
          <!-- GCM columns: contact info only (no assignments/certificate; no card page yet). -->
          <template v-if="isGcmColumnTab">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-col">
              <span id="col2" class="coltext">Name</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3" class="coltext">Username</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-col">
              <span id="col4" class="coltext">Email</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col5" class="coltext">Phone</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col6" class="coltext">Status</span>
            </div>
          </template>
        </div>
        <!-- Column headers for displays that are specifically small -->
        <div class="d-none d-sm-flex d-md-none row">
          <template v-if="tab == 'Patient'">
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col2_" class="coltext">Name</span>
            </div>
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3_" class="coltext">Date of Birth</span>
            </div>
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7_" class="coltext">Communication</span>
            </div>
          </template>
          <template v-if="tab == 'Provider'">
            <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col2_" class="coltext">Name</span>
            </div>
            <!-- Assignments column (stethoscope) temporarily hidden
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3_" class="coltext">Assignments</span>
            </div>
            -->
            <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7_" class="coltext">Communication</span>
            </div>
          </template>
          <template v-if="isNurseColumnTab">
            <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col2_" class="coltext">Name</span>
            </div>
            <!-- Assignments column (stethoscope) temporarily hidden
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3_" class="coltext">Assignments</span>
            </div>
            -->
            <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7_" class="coltext change">Communication</span>
            </div>
          </template>
          <template v-if="isAidColumnTab">
            <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col2_" class="coltext">Name</span>
            </div>
            <!-- Assignments column (stethoscope) temporarily hidden
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3_" class="coltext">Assignments</span>
            </div>
            -->
            <div class="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7_" class="coltext change">Communication</span>
            </div>
          </template>
          <!-- Compact GCM headers for sm-only breakpoint. -->
          <template v-if="isGcmColumnTab">
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col2_" class="coltext">Name</span>
            </div>
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col3_" class="coltext">Email</span>
            </div>
            <div class="col-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col7_" class="coltext">Status</span>
            </div>
          </template>
        </div>
        <div
          v-if="isMobile() && !loading && gridListPage.length === 0"
          class="d-sm-none mobile-list-empty"
        >
          {{ emptyListMessage }}
        </div>
        <div
          v-if="!isMobile() && !loading && gridListPage.length === 0"
          class="d-none d-sm-block grid-list-empty"
        >
          {{ emptyListMessage }}
        </div>
        <!-- @TODO: Bootstrap for the sizes between small and large -->
        <div
          v-for="(user, index) in gridListPage"
          class="patientrow"
          :key="user.patient_id"
        >
          <!-- The actual listing of patients/providers/etc.  -->
          <div class="d-sm-none mobile-list-item">
            <!-- List for xs screens (phones) -->
            <template v-if="tab == 'Patient'">
              <!-- <div class="col-8 top-row"> -->
              <div class="patient-name-container">
                <button 
                  @click="getPatientById(user.mid, user)" 
                  :class="['patient-chart-btn', { 'patient-chart-btn--disabled': !canViewPatientChart(user) }]"
                  :title="canViewPatientChart(user) ? `Switch to ${user.first_name} ${user.lastname}` : (isPatientPending(user) ? 'Patient must be verified before viewing their chart' : 'You do not have permission to view patient charts')"
                >
                  {{ `${user.first_name} ${user.lastname}` }}
                </button>
              </div>
              <!-- </div> -->
              <div class="mobile-list-icons">
                <button
                  :title="canUsePatientCommunication(user) ? 'Write a note' : 'Unavailable until patient is verified'"
                  :disabled="!canUsePatientCommunication(user)"
                  @click="showNote(user.patient_id, user.email, index, user)"
                  class="mobile-icon-btn"
                >
                  <img src="@/assets/images/message-or-note.svg" alt="" width="22" height="22" />
                </button>
                <button
                  :title="canUsePatientCommunication(user) ? 'Write an order' : 'Unavailable until patient is verified'"
                  :disabled="!canUsePatientCommunication(user)"
                  @click="showOrder(user.patient_id, user)"
                  class="mobile-icon-btn"
                >
                  <img src="@/assets/images/order.png" alt="" width="22" height="22" />
                </button>
              </div>
            </template>
            <template v-if="isNurseColumnTab">
              <!-- <div class="col-8 top-row"> -->
              <span
                @click="showNurseCard(user.acountnumber, user.licensenum)"
                class="coltext"
                >{{ `${user.firstname} ${user.lastname}, ${user.licensetype}` }}</span
              >
              <!-- </div> -->
              <div class="mobile-list-icons">
                <button title="Write an order" class="mobile-icon-btn">
                  <img src="@/assets/images/order.png" alt="" width="22" height="22" />
                </button>
              </div>
            </template>
            <template v-if="tab == 'Provider'">
              <span
                id="providerFirstName"
                @click="showProviderCard(index, user.acountnumber, user.npinumber)"
                class="coltext"
                >{{ `${user.firstname} ${user.lastname}` }}
              </span>
              <div class="mobile-list-icons">
                <button title="Write an order" class="mobile-icon-btn">
                  <img src="@/assets/images/order.png" alt="" width="22" height="22" />
                </button>
              </div>
            </template>
            <template v-if="tab == 'Aid'">
              <span id="alliedName" class="coltext"
                >{{ `${user.firstname} ${user.lastname}` }}
              </span>
              <div class="mobile-list-icons">
                <button title="Write an order" class="mobile-icon-btn">
                  <img src="@/assets/images/order.png" alt="" width="22" height="22" />
                </button>
              </div>
            </template>
            <!-- Mobile: GCM name only (no assignment icons yet). -->
            <template v-if="isGcmColumnTab">
              <span id="gcmNameMobile" class="coltext"
                >{{ `${user.firstname || ""} ${user.lastname || ""}`.trim() || "--" }}
              </span>
            </template>
          </div>
          <div class="columnrow columnrowtab d-none d-sm-flex d-md-none">
            <!-- Column headers for displays that are specifically small -->
            <template v-if="tab == 'Patient'">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <div class="patient-name-container">
                  <button 
                    @click="getPatientById(user.mid, user)" 
                    id="patientName" 
                    :class="['patient-chart-btn', { 'patient-chart-btn--disabled': !canViewPatientChart(user) }]"
                    :title="canViewPatientChart(user) ? `Switch to ${user.first_name} ${user.lastname}` : (isPatientPending(user) ? 'Patient must be verified before viewing their chart' : 'You do not have permission to view patient charts')"
                  >
                    {{ `${user.first_name} ${user.lastname}` }}
                  </button>
                </div>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="patientDob" class="coltext">{{ user.date_of_birth }}</span>
              </div>
              <div class="col-4 top-row">
                <span
                  id="patientNote"
                  :class="['coltext', 'msgiconbtn', { 'msgiconbtn--disabled': !canUsePatientCommunication(user) }]"
                  ><img
                    :title="canUsePatientCommunication(user) ? 'Write a note' : 'Unavailable until patient is verified'"
                    src="@/assets/images/message-or-note.svg"
                    width="40"
                    height="40"
                    @click="canUsePatientCommunication(user) && showNote(user.patient_id, user.email, index, user)"
                /></span>
                <span
                  id="patientOrder"
                  :class="['coltext', 'ordericonbtn', { 'ordericonbtn--disabled': !canUsePatientCommunication(user) }]"
                >
                  <img
                    :title="canUsePatientCommunication(user) ? 'Write an order' : 'Unavailable until patient is verified'"
                    src="@/assets/images/order.png"
                    width="35"
                    height="35"
                    @click="canUsePatientCommunication(user) && showOrder(user.patient_id, user)"
                  />
                </span>
              </div>
            </template>
            <template v-if="isNurseColumnTab">
              <div class="col-xs-2 col-sm-6 col-md-2 col-lg-2 col-xl-2 top-row">
                <span
                  @click="showNurseCard(user.acountnumber, user.licensenum)"
                  id="patientName"
                  class="coltext"
                  >{{ `${user.firstname} ${user.lastname}, ${user.licensetype}` }}
                </span>
              </div>
              <!-- Assignments placeholder (stethoscope column) temporarily hidden
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="patientDob" class="coltext assignments">{{ "--" }}</span>
              </div>
              -->
              <div class="col-6 top-row">
                <a
                  :href="'tel:' + user.primaryphone"
                  id="patientExpiry"
                  class="coltext"
                  >{{ user.primaryphone }}</a
                >
              </div>
            </template>
            <!-- @TODO: Determine what goes here for providers and allies -->
          </div>
          <div class="columnrow columnrowpc d-md-flex d-none">
            <!-- Column headers for diplays that are specifically medium or bigger, 
          including regular desktop view,  HHA NEEDS FINISHING! -->
            <template v-if="tab == 'Patient'">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row id-col">
                <div class="patient-id-container">
                  <button
                    @click="getPatientById(user.mid, user)"
                    id="patientExtern"
                    :class="['patient-chart-btn', { 'patient-chart-btn--disabled': !canViewPatientChart(user) }]"
                    :title="canViewPatientChart(user) ? `Switch to patient ${user.patient_id}` : (isPatientPending(user) ? 'Patient must be verified before viewing their chart' : 'You do not have permission to view patient charts')"
                  >
                    {{ user.patient_id }}
                  </button>
                </div>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <div class="patient-name-container">
                  <button 
                    @click="getPatientById(user.mid, user)" 
                    id="pName" 
                    :class="['patient-chart-btn', { 'patient-chart-btn--disabled': !canViewPatientChart(user) }]"
                    :title="canViewPatientChart(user) ? `Switch to ${user.first_name} ${user.lastname}` : (isPatientPending(user) ? 'Patient must be verified before viewing their chart' : 'You do not have permission to view patient charts')"
                  >
                    {{ `${user.first_name} ${user.lastname}` }}
                  </button>
                </div>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-1 col-lg-1 col-xl-1 top-row">
                <span id="patientDob" class="coltext">{{ user.date_of_birth }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="patientPhone" class="coltext">{{ user.contact_number }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="patientAssign" class="coltext">{{ user.assignment_date }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span
                  id="patientNote"
                  :class="['coltext', 'msgiconbtn', { 'msgiconbtn--disabled': !canUsePatientCommunication(user) }]"
                  ><img
                    :title="canUsePatientCommunication(user) ? 'Write a note' : 'Unavailable until patient is verified'"
                    src="@/assets/images/message-or-note.svg"
                    width="40"
                    height="40"
                    @click="canUsePatientCommunication(user) && showNote(user.patient_id, user.email, index, user)"
                /></span>
                <span
                  id="patientOrder"
                  :class="['coltext', 'ordericonbtn', { 'ordericonbtn--disabled': !canUsePatientCommunication(user) }]"
                >
                  <img
                    :title="canUsePatientCommunication(user) ? 'Write an order' : 'Unavailable until patient is verified'"
                    src="@/assets/images/order.png"
                    width="35"
                    height="35"
                    @click="
                      canUsePatientCommunication(user) &&
                        showOrderQmodal(user.patient_id, user.first_name, user.lastname, user)
                    "
                  />
                </span>
                <!-- Assignment tool (stethoscope) temporarily hidden
                <span
                  id="assignNursetopatient"
                  :class="['coltext', 'ordericonbtn', { 'ordericonbtn--disabled': !canUsePatientCommunication(user) }]"
                >
                  <img
                    :title="canUsePatientCommunication(user) ? 'Assign a Nurse' : 'Unavailable until patient is verified'"
                    src="@/assets/images/nurse-stethoscope.png"
                    width="35"
                    height="35"
                    @click="
                      canUsePatientCommunication(user) &&
                        showNurseModule(
                          user.patient_id,
                          user.accountnumber,
                          user.first_name + ' ' + user.lastname,
                          user
                        )
                    "
                  />
                </span>
                -->
              </div>
              <div class="col-xs-2 col-sm-4 col-md-1 col-lg-1 col-xl-1 top-row">
                <div class="patientStatus coltext">
                  <button
                    v-if="isPatientPending(user)"
                    type="button"
                    class="patient-status-link"
                    @click="openPendingPatientInviteModal(user)"
                  >
                    {{ unverifiedLabel(user.accntstatus) }}
                  </button>
                  <span v-else>{{ user.accntstatus }}</span>
                </div>
              </div>
            </template>
            <template v-if="isNurseColumnTab">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-row">
                <span
                  @click="showNurseCard(user.acountnumber, user.licensenum)"
                  id="patientName"
                  class="coltext"
                  >{{ `${user.firstname} ${user.lastname}, ${user.licensetype}` }}</span
                >
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="nurseUser" class="coltext">{{ user.licensenum }}</span>
              </div>

              <!-- Assignments column (stethoscope) temporarily hidden
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span
                  id="assignNursetopatient"
                  @click="showAssignments(user.assignments)"
                  class="coltext ordericonbtn"
                >
                  <img
                    title="Assign a Patient"
                    src="@/assets/images/nurse-stethoscope.png"
                    width="35"
                    height="35"
                    @click="getAccountPatients(user)"
                  />
                </span>
              </div>
              -->
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="nurseCommunication" class="coltext">
                  <img
                    title="Nurse Assignment"
                    src="@/assets/images/message-or-note.svg"
                    width="35"
                    height="35"
                    @click="
                      showMsgBoard(
                        user.primaryphone,
                        user.licensenum,
                        user.firstname,
                        user.lastname,
                        user.email
                      )
                    "
                  />
                </span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="patientStatus" class="coltext">Active</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="patientExpiry" class="coltext">{{ user.licenseexpdate }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="patientExpiry" class="coltext">{{ user.insuranceEnd }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <a
                  :href="'tel:' + user.primaryphone"
                  id="patientExpiry"
                  class="coltext"
                  >{{ user.primaryphone }}</a
                >
              </div>
              <!-- <div class="result-item" :id="'ncard' + user.licensenum">
                <h2 class="header3 capitalize">
                  <span>{{
                    `${user.firstname.toLowerCase()} ${user.lastname.toLowerCase()}, ${
                      user.licensetype
                    }`
                  }}</span>
                </h2>
                <current-nurse-bio :provider="user" />
              </div> -->
            </template>
            <template v-if="tab == 'Provider'">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="providerExtern" class="coltext">{{
                  user.subaccountnumber
                }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-row">
                <span
                  @click="showProviderCard(index, user.acountnumber, user.npinumber)"
                  id="providerName"
                  class="coltext"
                  >{{ `${user.firstname} ${user.lastname}` }}</span
                >
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="providerNpi" class="coltext">{{ user.npinumber }}</span>
              </div>
              <!-- Assignments column (stethoscope) temporarily hidden
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="providerAssignment" class="coltext">
                  <img
                    title="Provider Assignment"
                    src="@/assets/images/nurse-stethoscope.png"
                    width="35"
                    height="35"
                    @click="getProviderAccountPatients(user)"
                  />
                </span>
              </div>
              -->
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="providerCommunication" class="coltext">
                  <img
                    title="Provider Assignment"
                    src="@/assets/images/message-or-note.svg"
                    width="35"
                    height="35"
                    @click="
                      showMsgBoard(
                        user.tel,
                        user.npinumber,
                        user.firstname,
                        user.lastname,
                        user.email
                      )
                    "
                  />
                </span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="providerStatus" class="coltext">{{ user.status }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="providerEmail" class="coltext">{{ user.email }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="providerPhone" class="coltext">{{ user.tel }}</span>
              </div>
            </template>
            <template v-if="tab == 'Aid'">
              <!-- @TODO: NEEDS FINISHING! -->
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-row">
                <span
                  id="alliednurseFirstName"
                  @click="showAidCard(user.acountnumber, user.certificatenumber)"
                  class="coltext"
                  >{{ `${user.firstname}` + `${user.lastname}` }}
                </span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="alliednurseUsername" class="coltext">{{ user.username || '--' }}</span>
              </div>
              <!-- Assignments column (stethoscope) temporarily hidden
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span
                  id="alliedHomeHealth AidnurseAssignment"
                  class="coltext ordericonbtn"
                >
                  <img
                    title="Home Health Assignment"
                    src="@/assets/images/nurse-stethoscope.png"
                    width="35"
                    height="35"
                    @click="getAccountPatients(user)"
                  />
                </span>
              </div>
              -->
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="alliednurseCommunication" class="coltext">
                  <img
                    title="Home Health Aid  Communication Board"
                    src="@/assets/images/message-or-note.svg"
                    width="35"
                    height="35"
                    @click="
                      showMsgBoard(
                        user.primaryphone,
                        user.certificatenumber,
                        user.firstname,
                        user.lastname,
                        user.email
                      )
                    "
                  />
                </span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="alliednurseStatus" class="coltext"
                  >{{ `${user.activestatus}` }}
                </span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="alliednurseHasCert" class="coltext">{{ user.hasCertificate || '--' }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="alliednurseLicense" class="coltext"
                  >{{ `${user.certificatenumber}` }}
                </span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-1 col-xl-1 top-row">
                <span id="alliednurseAccountStatus" class="coltext">{{ user.accountStatus || '--' }}</span>
              </div>
            </template>
            <!-- Desktop GCM row values (from GetAccountGeriatricCareManagers). -->
            <template v-if="isGcmColumnTab">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-row">
                <span id="gcmName" class="coltext"
                  >{{ `${user.firstname || ""} ${user.lastname || ""}`.trim() || "--" }}</span
                >
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="gcmUsername" class="coltext">{{ user.username || "--" }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-3 col-xl-3 top-row">
                <span id="gcmEmail" class="coltext">{{ user.email || "--" }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="gcmPhone" class="coltext">{{ user.primaryphone || "--" }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                <span id="gcmStatus" class="coltext">{{ user.accountStatus || user.activestatus || "--" }}</span>
              </div>
            </template>
          </div>
          <!-- Supposed to be nurse card -->
          <div v-if="tab === 'Nurse'">
            <div class="result-item" :id="'ncard' + user.licensenum">
              <h2 v-if="!isMobile()" class="header3 capitalize">
                <span>{{
                  `${user.firstname} ${user.lastname}, ${user.licensetype}`
                }}</span>
              </h2>
              <current-nurse-bio :nurseLList="user" />
            </div>
          </div>

          <note-popup
            :time="noteTime"
            ref="notePopup"
            class="note__popup"
            :type="notePopupDefaultType"
            :patient="user"
            :pEmail="patientEmail||user.email"
            :id="'note__popup' + user.patient_id"
            v-show="tab == 'Patient' && activeNotePopupId === user.patient_id && user.patient_id"
            @closeNote="activeNotePopupId = null"
            @note-saved="activeNotePopupId = null"
          />
          <order-popup
            class="order__popup"
            :patient="user"
            :orderNum="newOrderNum"
            :id="'order__popup' + user.patient_id"
            v-if="tab == 'Patient' && activeOrderPopupId == user.patient_id && user.patient_id"
            :prov="provData"
            @close="handleOrderPopupClose"
          />
          <pendingorder-popup
            v-if="tab == 'Patient' && pendingOrderPopupId == user.patient_id && user.patient_id"
            class="pendingorder_popup"
            ref="pndordpop"
            :orderNum="orderNum"
            :patient="user"
            :id="'pendingorder_popup' + user.patient_id"
            :order="pendingordData"
            :pendingDetails="pendingDetails"
            :prov="provData"
            @childGetAccountPendingOrdersByPatID="handlePendingOrderClose"
          />
        </div>
        <!--Pageniation Area-->
        <pagination-info ref="pagination-info" />
        <pagination ref="pagination" @pagination:change-page="paginate" />
        <!-- This is the PickList for assigning multiples nurses to one patient -->
        <PickList
          v-if="assignmentId && tab == 'Patient'"
          v-model="nursesPL"
          @move-to-source="movingToNursePool($event)"
          :selection.sync="nurseassigned"
          :stripedRows="true"
          listStyle="height:342px"
          dataKey="pmid"
        >
          <template #sourceheader> Available </template>
          <template #targetheader>
            {{ PListPatientName }} <br />
            Selected
          </template>
          <template #item="slotProps">
            <div class="product-item">
              <div class="image-container">
                <img
                  src="@/assets/images/nurse-avatar.png"
                  alt="nurse image"
                  height="40"
                  width="40"
                />
              </div>
              <div class="product-list-detail">
                <h5 class="mb-2">
                  {{ slotProps.item.firstname }} {{ slotProps.item.lastname }}
                </h5>
                <i class="pi pi-tag product-category-icon"></i>
                <span class="product-category"
                  >License Number: {{ slotProps.item.licensenum }}</span
                >
              </div>
              <div class="product-list-action">
                <h6 class="mb-2">License Type: {{ slotProps.item.licensetype }}</h6>
                <span class="product-badge">Email:{{ slotProps.item.email }}</span>
              </div>
            </div>
          </template>
        </PickList>
        <div
          v-if="assignmentId && tab == 'Patient'"
          class="picklist-close-save button-container"
        >
          <button
            class="btn btn-secondary button"
            @click="closeNurseAssigned()"
            value="CLOSE"
          >
            CLOSE
          </button>
          <button
            class="btn btn-primary button"
            @click="saveNurseAssigned($event, nursesPL[1])"
            value="SAVE"
          >
            SAVE
          </button>
        </div>
        <!-- This is the PickList to assign multiple patients to one nurse -->
        <PickList
          v-if="patientasID && tab == 'Nurse'"
          v-model="patientPL"
          @move-to-source="movingToPatientPool($event)"
          :selection.sync="patientassigned"
          :stripedRows="true"
          listStyle="height:342px"
          dataKey="pid"
        >
          <template #sourceheader> Available </template>
          <template #targetheader>
            {{ PListPatientName }} <br />
            Assigned
          </template>
          <template #item="slotProps">
            <div class="product-item">
              <div class="image-container">
                <img
                  src="@/assets/images/nurse-avatar.png"
                  alt="nurse image"
                  height="40"
                  width="40"
                />
              </div>
              <div class="product-list-detail">
                <h5 class="mb-2">
                  {{ slotProps.item.first_name }} {{ slotProps.item.lastname }}
                </h5>
                <span class="product-category"
                  >Date of Birth: {{ slotProps.item.date_of_birth }}</span
                >
              </div>
              <div class="product-list-action">
                <h6 class="mb-2">Patient ID: {{ slotProps.item.psersonalID }}</h6>
                <span class="product-badge">Email:{{ slotProps.item.email }}</span>
              </div>
            </div>
          </template>
        </PickList>
        <div
          v-if="patientasID && tab == 'Nurse'"
          class="picklist-close-save button-container"
        >
          <button
            class="btn btn-secondary button"
            @click="closePatientAssigned()"
            value="CLOSE"
          >
            CLOSE
          </button>
          <button
            class="btn btn-primary button"
            @click="savePatientAssigned($event, patientPL[1])"
            value="SAVE"
          >
            SAVE
          </button>
        </div>
        <!-- This is the PickList to assign multiple patients to one provider -->
        <PickList
          v-if="patientasID && tab == 'Provider'"
          v-model="patientPL"
          @move-to-source="movingToPatientPool($event)"
          :selection.sync="patientassigned"
          :stripedRows="true"
          listStyle="height:342px"
          dataKey="pid"
        >
          <template #sourceheader> Available </template>
          <template #targetheader>
            {{ PListPatientName }} <br />
            Assigned
          </template>
          <template #item="slotProps">
            <div class="product-item">
              <div class="image-container">
                <img
                  src="@/assets/images/nurse-avatar.png"
                  alt="nurse image"
                  height="40"
                  width="40"
                />
              </div>
              <div class="product-list-detail">
                <h5 class="mb-2">
                  {{ slotProps.item.first_name }} {{ slotProps.item.lastname }}
                </h5>
                <i class="pi pi-tag product-category-icon"></i>
                <span class="product-category"
                  >Date of Birth: {{ slotProps.item.date_of_birth }}</span
                >
              </div>
              <div class="product-list-action">
                <h6 class="mb-2">Patient ID: {{ slotProps.item.psersonalID }}</h6>
                <span class="product-badge">Email:{{ slotProps.item.email }}</span>
              </div>
            </div>
          </template>
        </PickList>
        <div
          v-if="patientasID && tab == 'Provider'"
          class="picklist-close-save button-container"
        >
          <button
            class="btn btn-secondary button"
            @click="closePatientAssigned()"
            value="CLOSE"
          >
            CLOSE
          </button>
          <button
            class="btn btn-primary button"
            @click="saveProviderAssigned($event, patientPL[1])"
            value="SAVE"
          >
            SAVE
          </button>
        </div>
        <!-- Assign patients to one allied professional (UI only; backend pending) -->
        <PickList
          v-if="patientasID && tab == 'AlliedPro'"
          v-model="patientPL"
          @move-to-source="movingToPatientPool($event)"
          :selection.sync="patientassigned"
          :stripedRows="true"
          listStyle="height:342px"
          dataKey="pid"
        >
          <template #sourceheader> Available </template>
          <template #targetheader>
            {{ PListPatientName }} <br />
            Assigned
          </template>
          <template #item="slotProps">
            <div class="product-item">
              <div class="image-container">
                <img
                  src="@/assets/images/nurse-avatar.png"
                  alt="patient"
                  height="40"
                  width="40"
                />
              </div>
              <div class="product-list-detail">
                <h5 class="mb-2">
                  {{ slotProps.item.first_name }} {{ slotProps.item.lastname }}
                </h5>
                <span class="product-category"
                  >Date of Birth: {{ slotProps.item.date_of_birth }}</span
                >
              </div>
              <div class="product-list-action">
                <h6 class="mb-2">Patient ID: {{ slotProps.item.psersonalID }}</h6>
                <span class="product-badge">Email:{{ slotProps.item.email }}</span>
              </div>
            </div>
          </template>
        </PickList>
        <div
          v-if="patientasID && tab == 'AlliedPro'"
          class="picklist-close-save button-container"
        >
          <button
            class="btn btn-secondary button"
            @click="closePatientAssigned()"
            value="CLOSE"
          >
            CLOSE
          </button>
          <button
            class="btn btn-primary button"
            @click="saveAlliedProPatientAssigned($event, patientPL[1])"
            value="SAVE"
          >
            SAVE
          </button>
        </div>
        <!-- Assign patients to one home health aide (same layout as Nurse / Provider) -->
        <PickList
          v-if="patientasID && tab == 'Aid'"
          v-model="patientPL"
          @move-to-source="movingToPatientPool($event)"
          :selection.sync="patientassigned"
          :stripedRows="true"
          listStyle="height:342px"
          dataKey="pid"
        >
          <template #sourceheader> Available </template>
          <template #targetheader>
            {{ PListPatientName }} <br />
            Assigned
          </template>
          <template #item="slotProps">
            <div class="product-item">
              <div class="image-container">
                <img
                  src="@/assets/images/nurse-avatar.png"
                  alt="patient"
                  height="40"
                  width="40"
                />
              </div>
              <div class="product-list-detail">
                <h5 class="mb-2">
                  {{ slotProps.item.first_name }} {{ slotProps.item.lastname }}
                </h5>
                <span class="product-category"
                  >Date of Birth: {{ slotProps.item.date_of_birth }}</span
                >
              </div>
              <div class="product-list-action">
                <h6 class="mb-2">Patient ID: {{ slotProps.item.psersonalID }}</h6>
                <span class="product-badge">Email:{{ slotProps.item.email }}</span>
              </div>
            </div>
          </template>
        </PickList>
        <div
          v-if="patientasID && tab == 'Aid'"
          class="picklist-close-save button-container"
        >
          <button
            class="btn btn-secondary button"
            @click="closePatientAssigned()"
            value="CLOSE"
          >
            CLOSE
          </button>
          <button
            class="btn btn-primary button"
            @click="saveAidPatientAssigned($event, patientPL[1])"
            value="SAVE"
          >
            SAVE
          </button>
        </div>
      </div>
      <!-- <div v-if="assignedPatients" class="assignments-container">
        <div class="assignments-modal">
          <div v-for="(date, patient) in assignedPatients" class="assignments-list">
            <span class="assignedPatientName">{{ patient }}</span>
            <span class="assignedPatientDate">{{ date }}</span>
          </div>
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-secondary"
              @click="assignedPatients = null"
            >
              Close
            </button>
          </div>
        </div>
      </div> -->
      <!-- This is the communications modal -->
      <div v-if="wannMsg" class="combox-parent col-sm-12 col-md-12 col-lg-12">
        <div class="container">
          <div class="mbox-verticleflex">
            <form id="msgform">
              <div class="field-items">
                <label>Communication Type:</label>
                <select id="comtype" @change="SetOptionValue">
                  <option selected="selected" value="selected">
                    Select Communication Type
                  </option>
                  <option value="SMS">SMS</option>
                  <option value="Email">Email</option>
                  <option value="Call">Call</option>
                </select>
              </div>
              <div class="field-items">
                <label>To:</label>
                <input type="text" id="tofield" class="f-field" :value="nursName" />
                <input
                  type="hidden"
                  id="msgtohiddenfield"
                  :value="this.allData.patient.externId"
                />
              </div>
              <div v-if="smsOption" class="field-items">
                <label>Phone Number:</label>
                <input type="text" id="smsfield" class="f-field" :value="nursPhone" />
                <button
                  id="calltrigger"
                  v-if="callOption"
                  @click="CallProvider"
                  value="Call"
                  class="btn btn-primary"
                >
                  Call
                </button>
              </div>
              <div v-if="emailOption" class="field-items">
                <label>Email Address:</label>
                <input type="text" id="emailfield" class="f-field" :value="nursEmail" />
              </div>
              <div class="field-items">
                <label>Subject:</label>
                <input type="text" id="subjectfield" class="f-field" value="" />
              </div>
              <div class="field-items">
                <label>Message</label>
                <textarea
                  v-if="callOption != true"
                  id="msgboxfield"
                  class="f-field"
                  value=""
                >
                </textarea>
              </div>
              <div class="btndiv">
                <button
                  type="button"
                  @click="SendMessages"
                  class="btn btn-primary"
                  value="Submit"
                >
                  Submit
                </button>
                <button
                  type="button"
                  @click="closeMsgBoard"
                  class="btn btn-warning"
                  value="Close"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--EndTab-->
  <div
    v-if="pendingPatientInviteModal"
    class="patient-invite-modal-overlay"
    @click.self="closePendingPatientInviteModal"
  >
    <div class="patient-invite-modal" role="dialog" aria-labelledby="patient-invite-title">
      <p class="patient-invite-modal__name">{{ patientInviteDisplayName }}</p>
      <p class="patient-invite-modal__email">{{ pendingPatientInviteModal.email }}</p>
      <div class="patient-invite-modal__actions">
        <button
          type="button"
          class="btn btn-primary"
          :disabled="patientInviteSending"
          @click="sendPatientVerificationInvitation"
        >
          {{ patientInviteSending ? "Sending…" : "Send Invitation" }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          @click="closePendingPatientInviteModal"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { placePhoneCall, sendTextMessage } from "@/api/smsApi";
import { messagingSender } from "@/utils/messagingSender";
// import CurrentNurseBio from "@/components/private-layouts/nurses/CurrentNurseBio"
import OrderPopup from "@/components/private-layouts/OrderPopup.vue";
import PendingOrderPopup from "@/components/private-layouts/PendingOrderPopup.vue";
import NotePopup from "@/components/private-layouts/NotePopup.vue";
import WelcomeQuickNavSearch from "./WelcomeQuickNavSearch.vue";
import WelcomeHealthRecords from "./WelcomeHealthRecords.vue";
import OrderWidget from "@/components/private-layouts/OrderWidget.vue";
import { mapGetters, mapActions } from "vuex";
import {
  provAssignmentById,
  enterPatientChartAndRefresh,
} from "@/api/sessionApi";
import {
  getRelations,
  getFormattedRelationsList,
  getFormattedMeters,
} from "@/data/getters";
import RelationsListDropdown from "@/components/includes/relations/RelationsListDropdown";
import { getLatestTime } from "@/api/dataApi";
import { getPreferences, updatePreferences } from "@/api/userApi";
import Pagination from "@/components/includes/pagination/Pagination";
import PaginationInfo from "@/components/includes/pagination/PaginationInfo";
import GridNurseBio from "../welcome/GridNurseBio";
import CurrentProviderBio from "@/components/private-layouts/providers/CurrentProviderBio.vue";
import AddUserForm from "./AddUserForm.vue";
import _ from "lodash";
import { h } from "vue";
import router from "@/router/index";
import { usePrivilegesStore } from "@/stores/privileges";
import { useSessionSelfStore } from "@/stores/sessionSelf";
import { sessionActorFrom } from "@/utils/sessionIdentity";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import { isUnverifiedStatus, unverifiedLabel } from "@/utils/pendingAccountStatus";
import { noteTypeForAccountType } from "@/constants/noteTypes";
import { legacyAccountType, npiFromAccountType } from "@/utils/accountTypeLabel";

export default {
  name: "HomeGrid",
  data() {
    return {
      activeNotePopupId: null,
      activeOrderPopupId: null,
      pendingOrderPopupId: null,
      orderWidgetDetailOpen: false,
      accounttype: "",
      assignedPatients: null,
      assignmentId: null,
      patientasID: null,
      userid: "", //this will open up the right order for each patient
      ispendingordermodal: false,
      smsOption: false,
      emailOption: false,
      callOption: false,
      idnurseID: "",
      idnurseUniqueID: "",
      idhhaUniqueID: "",
      idproviderID: "",
      idproviderUniqueID: "",
      provName: "",
      orderquestionmodal: "", //variable that decides if the modal is showing
      activeTab: 0,
      latestTimes: {},
      loading: true,
      filtered: true,
      filterList: [],
      clientFname: "",
      clientLname: "",
      patients: [],
      patientEmail:"",
      pateintsGrid: [],
      pendingorders: [],
      allpendingorders: [],
      itemsPerPage: 10,
      preferences: {},
      // The pending-order popups' order: the one whose row was opened.
      orderNum: null,
      // The new-order popup's number, from systemData.GetOrderNumber. Its own
      // field (MV-26): the answer is a placeholder (the number is assigned
      // when the order is saved), and sharing `orderNum` handed it to a
      // pending-order popup still open, whose next line then named no order.
      newOrderNum: null,
      noteTime: "",
      nursesPL: null,
      providerList: [],
      nursName: "",
      patientPL: null,
      PListPatientName: null,
      nurses: [],
      nurseassigned: [],
      patientassigned: [],
      nursename: "",
      patId: "",
      accountId: "",
      gridList: [],
      gridListPage: [],
      nurseList: [],
      homeaidList: [],
      homeaidLList: [],
      alliedProList: [],
      indivprovList: [],
      viewNursecard: false,
      viewAidcard: false,
      viewProvidercard: false,
      nurseLList: [],
      ordstatus: "",
      indvidualNurse: {},
      wannMsg: false,
      nursEmail: "",
      nursPhone: "",
      numberofPendingOrder: "", //Number Of Pending Orders
      pendingordData: {},
      pendingDetails: {},
      ordType: "",
      uidpendingorder: 0,
      profflicense: "",
      provData: null,
      //togglePendingOrder:true,
      // selectedNurse: null,
      position: {
        x: 400,
        y: 300,
      },
      offset: {
        x: 0,
        y: 0,
      },
      showingAddUser: false,
      globalRoleMemberIds: {
        patients: [],
        nurses: [],
        providers: [],
        aids: [],
        alliedPros: [],
        // Member unique_IDs for org-level Geriatric Care Managers group.
        gcm: [],
      },
      globalRoleMembersLoaded: false,
      globalRoleMembersPromise: null,
      ownPatientsMemberIds: [],
      rawPatientsGrid: [],
      rawNurseList: [],
      rawProviderList: [],
      rawAidList: [],
      rawAlliedProList: [],
      // Unfiltered API payload for GCM; gcmList is membership-filtered for the grid.
      rawGcmList: [],
      idAlliedProUniqueID: "",
      gcmList: [],
      patientRowsFromGroups: false,
      pendingPatientInviteModal: null,
      patientInviteSending: false,
    };
  },
  props: {
    tab: String,
  },
  watch: {
    filtered() {
      this.paginate(1);
    },
    filterList(newList) {
      let i;
      for (i = 0; i < this.patients.length; i++) {
        this.patients[i].active = !_.includes(newList, this.patients[i].id)
          ? "Active"
          : "Invacive";
      }
    },
    async tab() {
      // Clear all popup IDs when switching tabs to prevent unwanted popups
      this.activeOrderPopupId = null;
      this.activeNotePopupId = null;
      this.pendingOrderPopupId = null;
      this.closePatientAssigned();

      if (this.tab == "Patient") {
        await this.getAccountType(this.allData.patient.externId);
        console.log(this.allData);
        this.gridList = this.patientsGrid;
        // GetAccountPendingOrders is called in getAccountType after accounttype is set
      }
      if (this.tab == "Nurse") {
        this.gridList = this.nurseList;
      }
      if (this.tab == "Aid") {
        this.gridList = this.homeaidList;
      }
      if (this.tab == "AlliedPro") {
        this.gridList = this.alliedProList;
      }
      // Bind the last staff tab to the GCM roster.
      if (this.tab == "GCM") {
        this.gridList = this.gcmList;
      }
      if (this.tab == "Provider") {
        this.gridList = this.providerList;
      }
      this.paginate(1);
    },
  },
  components: {
    // "quick-nav-search": WelcomeQuickNavSearch,
    // "relations-list-dropdown": RelationsListDropdown,
    // "welcome-health-records": WelcomeHealthRecords,
    "order-popup": OrderPopup,
    "note-popup": NotePopup,
    "account-nurse-bio": GridNurseBio,
    "pendingorder-popup": PendingOrderPopup,
    Pagination,
    PaginationInfo,
    "current-nurse-bio": GridNurseBio,
    "current-provider-bio": CurrentProviderBio,
    "order-widget": OrderWidget,
    AddUserForm,
  },
  async mounted() {
    let that = this;
    await this.getAccountType(this.allData.patient.externId);
    await this.ensureGlobalRoleMembersLoaded();
    if (this.isOrgAdministrator) {
      await Promise.all([
        this.getAccountNurses(),
        this.getAccountAides(),
        this.getAccountProviders(),
        this.getAccountAlliedProfessionals(),
        // Load GCM roster alongside other staff lists for admin HomeGrid tabs.
        this.getAccountGeriatricCareManagers(),
      ]);
    }
    if (this.tab === "Patient") {
      this.GetAccountPendingOrders();
    }
    /* getPreferences().then((data) => {
      that.$set(that, "preferences", data);
      let paginate = that.filterList === null;
      // that.$set(that, "filterList", data.provider_filter);
      that["filterList"] = data.provider_filter;
      that.paginate(1);
      //let togglePendingOrder=true;

    });*/
    this.uidpendingorder++;

    let res = await getLatestTime({});
    if (res && Array.isArray(res)) {
      res.forEach((upload) => {
        // that.$set(that.latestTimes, upload.who, upload.when);
        that.latestTimes[upload.who] = upload.when;
      });
    }
    this.loading = false;
    // this.getAccountNurses();
    // this.showNurseModule(1);
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    canViewPatientCharts() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.VIEW_PATIENT_CHART);
    },
    canAssignStaffToPatients() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.ASSIGN_STAFF_TO_PATIENTS);
    },
    canWriteNotes() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.WRITE_NOTES);
    },
    canOrderView() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.ORDER_VIEW);
    },
    canOrderWrite() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.ORDER_WRITE);
    },
    isAidColumnTab() {
      return this.tab === "Aid";
    },
    // Nurse and Allied Pro grids share the same column layout.
    isNurseColumnTab() {
      return this.tab === "Nurse" || this.tab === "AlliedPro";
    },
    // Separate column layout from Nurse/Allied (no license/assignments columns).
    isGcmColumnTab() {
      return this.tab === "GCM";
    },
    emptyListMessage() {
      const labels = {
        Patient: "patients",
        Provider: "providers",
        Nurse: "nurses",
        Aid: "home health aides",
        AlliedPro: "allied professionals",
        GCM: "geriatric care managers",
      };
      const noun = labels[this.tab] || "records";
      return `No ${noun} found.`;
    },
    // Org-wide roster management requires Administrator account type.
    isOrgAdministrator() {
      return this.normalizeAccountType(this.accounttype) === "administrator";
    },
    relations: function () {
      return getRelations(this.allData);
    },
    // patientList: function () {
    //   // // console.log(this.allData)
    //   if (this.filterList === null) return null;
    //   let that = this;
    //   let result = getFormattedRelationsList(this.allData);
    //   result = result.map((relation) =>
    //     _.extend(
    //       { active: !_.includes(that.filterList, relation.id) ? "Active" : "Inactive" },
    //       relation
    //     )
    //   );
    //   result.shift();
    //   if (this.filtered) {
    //     result = _.filter(
    //       result,
    //       (relation) => !_.includes(that.filterList, relation.id)
    //     );
    //   }
    //   let finalResult = result.filter((patient) => !patient.admin);
    //   return finalResult;
    // },
    meters: function () {
      return getFormattedMeters(this.allData);
    },
    /** Initial NotePopup note kind; matches NotePopup `<option value="...">` strings. */
    notePopupDefaultType() {
      return noteTypeForAccountType(this.accounttype);
    },
    /** Logged-in staff unique_ID (MySQL self when loaded). */
    actorUniqueId() {
      return this.normalizeId(
        sessionActorFrom(this.allData, useSessionSelfStore().profile).unique_ID
      );
    },
    /** Sets the :patient prop for pendingorder-popup from OrderWidget by matching pid
     * to patientsGrid row
     */
    orderWidgetPopupPatient() {
      const o = this.pendingordData;
      if (!o || !o.pid) {
        return {};
      }
      const pidNorm = this.normalizeId(o.pid);
      const rows = this.patients;
      if (Array.isArray(rows)) {
        const match = rows.find(
          (p) =>
            this.normalizeId(p.patient_id) === pidNorm ||
            this.normalizeId(p.pid) === pidNorm
        );
        if (match) return match;
      }
      return {
        patient_id: o.pid,
        pid: o.pid,
        mid: o.pid,
        first_name: o.patient_first_name ?? o.first_name ?? "",
        lastname: o.patient_last_name ?? o.lastname ?? "",
        date_of_birth: o.date_of_birth ?? "",
      };
    },
    patientInviteDisplayName() {
      const p = this.pendingPatientInviteModal;
      if (!p) return "";
      return `${p.first_name} ${p.lastname}` || "Patient";
    },
  },
  methods: {
    ...mapActions("login", ["updateApplicationModel"]),
    normalizeId(value) {
      return String(value == null ? "" : value).trim();
    },
    normalizeGroupName(value) {
      return String(value || "")
        .trim()
        .toLowerCase();
    },
    normalizeAccountType(value) {
      return String(value || "")
        .trim()
        .toLowerCase();
    },
    // Not yet verified: Pending, or Expired once keyon's sweep has stored it
    // (keyon/lib/PendingAccountExpiry.php). Either way the chart and its
    // actions stay closed, and the status opens the resend, which revives it.
    isPatientPending(user) {
      return isUnverifiedStatus(user?.accntstatus);
    },
    unverifiedLabel,
    openPendingPatientInviteModal(user) {
      const email = user?.email;
      if (!email) {
        alert("This patient does not have an email address on file.");
        return;
      }
      this.pendingPatientInviteModal = {
        patient_id: this.normalizeId(user.patient_id),
        first_name: user.first_name,
        lastname: user.lastname,
        email,
      };
      this.patientInviteSending = false;
    },
    closePendingPatientInviteModal() {
      this.pendingPatientInviteModal = null;
      this.patientInviteSending = false;
    },
    async sendPatientVerificationInvitation() {
      const patient = this.pendingPatientInviteModal;
      if (!patient) return;

      const accountnumber = this.allData?.patient?.externId2;
      const uniqueNine = this.normalizeId(patient.patient_id);
      if (!accountnumber || !uniqueNine) {
        alert("Missing account or patient identifier.");
        return;
      }

      this.patientInviteSending = true;
      try {
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          {
            Account: {
              API_Meth: "SendNewSubAccountEmail",
              accountnumber,
              uniquenine: uniqueNine,
              // This grid's patient_id is the CHART id, not the person's user
              // id that every other caller of this op sends, so the bridge
              // routes it to the patient's portal invitation instead
              // (bridgeMap 'Account.SendNewSubAccountEmail').
              patient_id: uniqueNine,
              accounttype: "Patient",
              accountholder: this.patientInviteDisplayName,
              usertoemail: patient.email,
              firstname: patient.first_name || "",
              lastname: patient.lastname || "",
            },
          },
          { headers: { "Content-Type": "application/json;" } }
        );
        if (res?.data?.status === "Successfull") {
          this.closePendingPatientInviteModal();
          if (this.$swal) {
            this.$swal({
              type: "success",
              title: "Invitation sent",
              text: "The patient verification email has been sent.",
            });
          }
        } else {
          const msg =
            res?.data?.message ||
            "Could not send the verification email. Please try again or contact an administrator.";
          alert(msg);
        }
      } catch (err) {
        alert(err?.message || "Could not send the verification email.");
      } finally {
        this.patientInviteSending = false;
      }
    },
    canViewPatientChart(user) {
      return this.canViewPatientCharts && !this.isPatientPending(user);
    },
    canUsePatientCommunication(user) {
      return !this.isPatientPending(user);
    },
    findPatientRowById(id) {
      const pid = this.normalizeId(id);
      const rows = Array.isArray(this.patientsGrid)
        ? this.patientsGrid
        : Array.isArray(this.patients)
          ? this.patients
          : [];
      return (
        rows.find(
          (p) =>
            this.normalizeId(p.patient_id) === pid || this.normalizeId(p.mid) === pid
        ) || null
      );
    },
    isStaffScopedPatientView() {
      const t = this.normalizeAccountType(this.accounttype);
      return [
        "provider",
        "nurse",
        "registered nurse",
        "licensed practical nurse",
        "home health aid",
        "home health aids",
        "home health aide",
        "home health aides",
        "allied professional",
        "allied professionals",
        // GCM sees patient list only (staff-scoped HomeGrid), not org roster tabs.
        "geriatric care manager",
        "geriatric care managers",
        "contact",
      ].includes(t);
    },
    rowPossibleIds(row) {
      return [
        row?.patient_id,
        row?.mid,
        row?.providerid,
        row?.providerID,
        row?.subaccountnumber,
        row?.externId,
        row?.externid,
        row?.licensenum,
        row?.npinumber,
        row?.certificatenumber,
        row?.pmid,
        row?.pid,
        row?.unique_ID,
      ]
        .map((v) => this.normalizeId(v))
        .filter((v) => v.length > 0);
    },
    rowBelongsToRole(row, roleKey) {
      const roleIds = new Set(
        (this.globalRoleMemberIds[roleKey] || []).map((id) => this.normalizeId(id))
      );
      if (!roleIds.size) return false;
      const candidates = this.rowPossibleIds(row);
      return candidates.some((id) => roleIds.has(id));
    },
    applyGroupMembershipFilters() {
      const patientsBase = Array.isArray(this.rawPatientsGrid)
        ? this.rawPatientsGrid
        : [];
      const nursesBase = Array.isArray(this.rawNurseList)
        ? this.rawNurseList
        : [];
      const providersBase = Array.isArray(this.rawProviderList)
        ? this.rawProviderList
        : [];
      const aidsBase = Array.isArray(this.rawAidList) ? this.rawAidList : [];
      const alliedBase = Array.isArray(this.rawAlliedProList)
        ? this.rawAlliedProList
        : [];
      // Filter GCM rows to members of the org GCM group (same as other staff roles).
      const gcmBase = Array.isArray(this.rawGcmList) ? this.rawGcmList : [];

      if (this.patientRowsFromGroups) {
        this.patientsGrid = patientsBase;
      } else if (this.isOrgAdministrator) {
        this.patientsGrid = patientsBase.filter((r) =>
          this.rowBelongsToRole(r, "patients")
        );
      } else if (this.isStaffScopedPatientView()) {
        const ownIds = new Set(
          (this.ownPatientsMemberIds || []).map((id) => this.normalizeId(id))
        );
        this.patientsGrid = patientsBase.filter((r) => {
          if (!ownIds.size) return false;
          const candidates = this.rowPossibleIds(r);
          return candidates.some((id) => ownIds.has(id));
        });
      } else {
        this.patientsGrid = patientsBase;
      }
      this.patients = this.patientsGrid;
      if (this.tab === "Patient") {
        this.gridList = this.patientsGrid;
        this.paginate(1);
      }
      if (this.isOrgAdministrator) {
        this.nurseList = nursesBase.filter((r) => this.rowBelongsToRole(r, "nurses"));
        this.providerList = providersBase.filter((r) =>
          this.rowBelongsToRole(r, "providers")
        );
        this.homeaidList = aidsBase.filter((r) => this.rowBelongsToRole(r, "aids"));
        this.alliedProList = alliedBase.filter((r) =>
          this.rowBelongsToRole(r, "alliedPros")
        );
        this.gcmList = gcmBase.filter((r) => this.rowBelongsToRole(r, "gcm"));
      }
    },
    async loadGroupMembersById(groupId) {
      if (!groupId) return [];
      let content = {
        Groups: {
          API_Meth: "GetGroupMembers",
          accountnumber: this.allData.patient.externId2,
          group_id: groupId,
          actor_unique_ID: this.actorUniqueId,
        },
      };
      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });
      const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
      return rows
        .map((m) => this.normalizeId(m.unique_ID))
        .filter((id) => id.length > 0);
    },

    async loadOwnedGroupMemberIds(ownerUniqueId, lowerNameCandidates) {
      const ownerId = this.normalizeId(ownerUniqueId);
      if (!ownerId) return new Set();
      const namesSet = new Set(
        (Array.isArray(lowerNameCandidates) ? lowerNameCandidates : [])
          .map((n) => this.normalizeGroupName(n))
          .filter((x) => x.length > 0)
      );
      if (!namesSet.size) return new Set();

      const groupsContent = {
        Groups: {
          API_Meth: "GetGroupsByOwner",
          accountnumber: this.allData.patient.externId2,
          owner_unique_ID: ownerId,
          actor_unique_ID: this.actorUniqueId,
        },
      };
      const groupsRes = await axios.post(CURR_API + "/tswebhook.php", groupsContent, {
        headers: { "Content-Type": "application/json;" },
      });
      const groups = Array.isArray(groupsRes?.data?.data) ? groupsRes.data.data : [];
      const matchingGroup = groups.find((g) => namesSet.has(this.normalizeGroupName(g?.name)));
      if (!matchingGroup?.id) return new Set();

      const memberIds = await this.loadGroupMembersById(Number(matchingGroup.id));
      return new Set(memberIds.map((x) => this.normalizeId(x)));
    },

    // PickList loaders call this when nurseInfo/patientInfo is empty or unusable.
    pickListLoadFailureAlert(entityKind, res) {
      const data = res?.data || {};
      const listKey = entityKind === "nurse" ? "nurseInfo" : "patientInfo";

      // tswebhook error envelope (e.g. GetAccountNurse with status Error).
      if (String(data.status).toLowerCase() === "error") {
        const detail = data.message || data.error || data.msg;
        alert(
          detail
            ? `Could not load the assignment list: ${detail}`
            : "Could not load the assignment list (server error)."
        );
        return;
      }

      // Error payload without a list array.
      if (data.error && !Array.isArray(data[listKey])) {
        alert(`Could not load the assignment list: ${data.error}`);
        return;
      }

      // List field set but not an array (e.g. nurseInfo null from PHP).
      if (data[listKey] != null && !Array.isArray(data[listKey])) {
        alert(
          "Could not load the assignment list (unexpected response from the server)."
        );
        return;
      }

      // Valid response shape but zero rows in the account.
      if (entityKind === "nurse") {
        alert(
          "No nurses are available for this account. Register active RN/LPN nurses and ensure their provider ID matches their staff account before assigning them to a patient."
        );
        return;
      }

      alert(
        "No patients are registered for this account. Add patients before assigning them to staff."
      );
    },

    pickListRequestErrorAlert(error) {
      const detail =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message;
      alert(
        detail
          ? `Could not load the assignment list: ${detail}`
          : "Could not load the assignment list. Please try again or contact an administrator."
      );
    },

    /** Deduped identifiers that may match proto_groups.owner_unique_ID for staff-owned "Patients" groups. */
    staffPatientsOwnerCandidates(row) {
      const raw = [
        row?.subaccountnumber,
        row?.unique_ID,
        row?.providerid,
        row?.providerID,
        row?.pmid,
        row?.pid,
        row?.licensenum,
        row?.certificatenumber,
        row?.npinumber,
      ];
      const out = [];
      const seen = new Set();
      for (const r of raw) {
        const id = this.normalizeId(r);
        if (id && !seen.has(id)) {
          seen.add(id);
          out.push(id);
        }
      }
      return out;
    },

    /**
     * Resolve staff-owned proto group "Patients": merge members across matching owner IDs (PHP rows vary by casing/source).
     */
    async resolveStaffPatientsProtoGroup(ownerCandidates) {
      const namesSet = new Set(["patients"]);
      const mergedAssigned = new Set();
      let primaryOwnerForSave = "";
      for (const ownerId of ownerCandidates) {
        if (!ownerId) continue;
        const groupsContent = {
          Groups: {
            API_Meth: "GetGroupsByOwner",
            accountnumber: this.allData.patient.externId2,
            owner_unique_ID: ownerId,
            actor_unique_ID: this.actorUniqueId,
          },
        };
        const groupsRes = await axios.post(CURR_API + "/tswebhook.php", groupsContent, {
          headers: { "Content-Type": "application/json;" },
        });
        const groups = Array.isArray(groupsRes?.data?.data) ? groupsRes.data.data : [];
        const matchingGroup = groups.find((g) =>
          namesSet.has(this.normalizeGroupName(g?.name))
        );
        if (matchingGroup?.id) {
          if (!primaryOwnerForSave) primaryOwnerForSave = ownerId;
          const memberIds = await this.loadGroupMembersById(Number(matchingGroup.id));
          memberIds.forEach((m) => mergedAssigned.add(m));
        }
      }
      return {
        ownerUniqueId: primaryOwnerForSave || ownerCandidates[0] || "",
        assignedSet: mergedAssigned,
      };
    },

    async loadGlobalRoleMembers() {
      let groupsContent = {
        Groups: {
          API_Meth: "GetGroupsByAccount",
          accountnumber: this.allData.patient.externId2,
        },
      };
      const groupsRes = await axios.post(CURR_API + "/tswebhook.php", groupsContent, {
        headers: { "Content-Type": "application/json;" },
      });
      const groups = Array.isArray(groupsRes?.data?.data) ? groupsRes.data.data : [];
      const byName = new Map();
      groups.forEach((g) => {
        byName.set(this.normalizeGroupName(g.name), Number(g.id));
      });

      const patientsId = byName.get("patients") || null;
      const nursesId = byName.get("nurses") || byName.get("nurse") || null;
      const providersId =
        byName.get("providers") || byName.get("provider") || null;
      const aidsId =
        byName.get("home health aids") ||
        byName.get("home health aid") ||
        byName.get("home health aides") ||
        byName.get("home health aide") ||
        null;
      const alliedProsId =
        byName.get("allied professionals") ||
        byName.get("allied professional") ||
        null;
      // Resolve org-level GCM group for membership filtering.
      const gcmId =
        byName.get("geriatric care managers") ||
        byName.get("geriatric care manager") ||
        null;

      const [patients, nurses, providers, aids, alliedPros, gcm] = await Promise.all([
        this.loadGroupMembersById(patientsId),
        this.loadGroupMembersById(nursesId),
        this.loadGroupMembersById(providersId),
        this.loadGroupMembersById(aidsId),
        this.loadGroupMembersById(alliedProsId),
        this.loadGroupMembersById(gcmId),
      ]);

      this.globalRoleMemberIds = { patients, nurses, providers, aids, alliedPros, gcm };
      this.globalRoleMembersLoaded = true;
      this.applyGroupMembershipFilters();
    },
    async loadOwnPatientsMembers() {
      const ownerId = this.normalizeId(
        this.allData?.patient?.externId || this.allData?.patient?.externid || ""
      );
      if (!ownerId) {
        this.ownPatientsMemberIds = [];
        return;
      }
      let content = {
        Groups: {
          API_Meth: "GetGroupsByOwner",
          accountnumber: this.allData.patient.externId2,
          owner_unique_ID: ownerId,
          actor_unique_ID: this.actorUniqueId,
        },
      };
      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });
      const groups = Array.isArray(res?.data?.data) ? res.data.data : [];
      const ownPatientsGroup = groups.find(
        (g) => this.normalizeGroupName(g.name) === "patients"
      );
      if (!ownPatientsGroup || !ownPatientsGroup.id) {
        this.ownPatientsMemberIds = [];
        return;
      }
      this.ownPatientsMemberIds = await this.loadGroupMembersById(
        Number(ownPatientsGroup.id)
      );
    },
    async loadPatientsForHomeGridFromGroups() {
      const ownerId = this.isStaffScopedPatientView()
        ? this.normalizeId(
            this.allData?.patient?.externId ||
              this.allData?.patient?.externid ||
              ""
          )
        : "";
      const content = {
        Groups: {
          API_Meth: "GetPatientsForHomeGrid",
          accountnumber: this.allData.patient.externId2,
          owner_unique_ID: ownerId || null,
        },
      };
      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });
      const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
      console.log("Rows ARRAY VEFORE PATEINTROW");
      console.log(rows);
      this.patientRowsFromGroups = true;
      console.log("Before Normalizaton FOr Home Group");
      console.log(this.rawPatientsGrid);
      this.rawPatientsGrid = rows.map((r) => ({
        ...r,
        mid: this.normalizeId(r.mid || r.patient_id || r.unique_ID),
        patient_id: this.normalizeId(r.patient_id || r.mid || r.unique_ID),
        email: r.email
      }));
      this.patientsGrid = this.rawPatientsGrid;
      this.patients = this.rawPatientsGrid;
      console.log("Groups Home Grid");
      console.log(this.patients);
      if (this.tab === "Patient") {
        this.gridList = this.patientsGrid;
        this.paginate(1);
      }
    },
    async ensureGlobalRoleMembersLoaded() {
      if (this.globalRoleMembersLoaded) return;
      if (this.globalRoleMembersPromise) {
        await this.globalRoleMembersPromise;
        return;
      }
      this.globalRoleMembersPromise = Promise.all([
        this.loadGlobalRoleMembers(),
        this.loadOwnPatientsMembers(),
      ])
        .catch((e) => {
          console.error("Failed to load global group membership for HomeGrid:", e);
        })
        .finally(() => {
          this.globalRoleMembersPromise = null;
        });
      await this.globalRoleMembersPromise;
    },
    isActive(id) {
      return !(this.filterList && _.includes(this.filterList, id));
    },
    orderWidgetDisplay(event) {
      if (!this.canOrderView) {
        alert("You do not have permission to look at orders.");
        return;
      }
      const el = $(".widget-container");
      if (el.css("display") === "none" || !el.hasClass("open")) {
        el.addClass("open").css("display", "flex");
      } else {
        el.removeClass("open").css("display", "none");
      }
    },
    startDrag(event) {
      this.offset = {
        x: event.offsetX,
        y: event.offsetY,
      };
    },
    onDrag(event) {
      if (event.clientX === 0 && event.clientY === 0) return;
      this.position = {
        x: event.clientX - this.offset.x,
        y: event.clientY - this.offset.y,
      };
    },
    endDrag(event) {
      this.offset = { x: event.offsetX, y: event.offsetY };
    },
    getWidgetPatient() {
      let pid = this.pendingordData.pid;
      return this.patients
        ? this.patients.find((patient) => patient.patient_id == pid)
        : null;
    },
    closeOrdQModal() {
      this.orderquestionmodal = ""; //close modal
    },
    showOrderQmodal(userid, fname, lname, user = null) {
      const row = user || this.findPatientRowById(userid);
      if (row && this.isPatientPending(row)) return;
      if (!this.canOrderWrite) {
        alert("You do not have permission to write orders");
        return;
      }
      if (this.canOrderView) {
        //check to see if the user has the appropriate permissions before running the code
        this.userid = userid;
        this.orderquestionmodal = "true";
        this.clientLname = lname;
        this.clientFname = fname;
        // console.log(fname + fname + " " + "ShowOrderQModal");
      } else {
        //show the alert to let user know that they don't have sufficient permissions
        alert(
          "User doesn't have sufficient permissions. PLease contact the administrator to update permissions."
        );
      }
    },
    modalShowOrderPopup() {
      //snow lets show the order modal
      this.showOrder(this.userid);
      //close the modal
      this.closeOrdQModal();
    },
    showAllPendingOrderModal() {
      if (!this.canOrderView) {
        alert("You do not have permission to look at orders.");
        return;
      }
      if (this.canOrderWrite) {
        this.ispendingordermodal = true
        this.pendingorders = this.allpendingorders
      }
      else {
        alert("This account doesn't have the appropriate permissions. Please contact the system Administrator.")
      }
    },
    showPendingOrderModal() {
      if (this.canOrderWrite) {
        this.ispendingordermodal = true;
        this.GetAccountPendingOrdersByPatID();
        //close qmodel
        this.closeOrdQModal();
      } else {
        alert(
          "This account doesn't have the appropriate permissions. Please contact the system Administrator."
        );
      }
    },
    closePendingOrderModal() {
      this.ispendingordermodal = false;
    },
    // Grab medication or procedure (stored in different places)
    pendingOrderMedProcLabel(ord) {
      if (!ord) return "—";
      const fromOrder = (ord.medication && String(ord.medication).trim()) || "";
      const fromJoin =
        (ord.med_medname && String(ord.med_medname).trim()) || "";
      return fromOrder || fromJoin || "—";
    },
    pendingOrderSignatureBlank(sig) {
      if (sig === null || sig === undefined) return true;
      return String(sig).trim() === "";
    },
    async GetAccountPendingOrders() {
      if (!this.accounttype) {
        return;
      }
      // Don't ask for orders this user may not read.
      //
      // Eight call sites reach this method and several fire per grid page, so
      // an organization administrator — who holds no `orders:read` — landed on
      // /welcome and issued this same request nine times, every one a 403. The
      // bridge answers a refusal with an empty result set, so the failures were
      // invisible: the pending-orders badge simply showed nothing, which reads
      // as "no orders are pending" rather than "you cannot see orders".
      // Leaving the badge empty is the honest outcome; the count is unknown,
      // not zero.
      if (!this.canOrderView) {
        this.numberofPendingOrder = "";
        this.allpendingorders = [];
        return;
      }
      // Only include patients currently shown in the visible grid page.
      let pids = this.gridListPage.map((p) => p.patient_id);
      if (!pids.length) {
        this.numberofPendingOrder = 0;
        this.allpendingorders = [];
        return;
      }
      let content = {
        Order: {
          API_Meth: "GetAccountPendingOrders",
          accountnumber: this.allData.patient.externId2,
          accountType: this.accounttype,
          pids: pids
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res)
          this.numberofPendingOrder = res.data.numofpending
          
          let orders = res.data.orders || [];
          this.allpendingorders = orders.sort((a, b) => {
            const dateA = a.orderdate || '';
            const dateB = b.orderdate || '';
            if (dateA !== dateB) {
              return dateB.localeCompare(dateA);
            }
            const orderNumA = a.ordernumber || '';
            const orderNumB = b.ordernumber || '';
            return orderNumB.localeCompare(orderNumA);
          });
        });
    },
    // async GetAccountPendingOrdersByPatID() {
    //   let content = {
    //     Order: {
    //       API_Meth: "GetAccountPendingOrdersByID",
    //       accountnumber: this.allData.patient.externId2,
    //       patientid: this.allData.patient.externId,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       // console.log(res);
    //       this.numberofPendingOrder = res.data.numofpending;
    //       //set the data variable so that we can reference it later witht he pending order grid
    //       // console.log(this);
    //       this.pendingorders = res.data.orders;
    //       // console.log(this.pendingorders);
    //     });
    // },
    async GetAccountPendingOrdersByPatID() {
      let content = {
        Order: {
          API_Meth: "GetAccountPendingOrdersByID",
          accountnumber: this.allData.patient.externId2,
          patientid: this.userid,
          accountType: this.accounttype,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          this.numberofPendingOrder = res.data.numofpending;
          //set the data variable so that we can reference it later witht he pending order grid
          // console.log(this);
          
          let orders = res.data.orders || [];
          this.pendingorders = orders.sort((a, b) => {
            const dateA = a.orderdate || '';
            const dateB = b.orderdate || '';
            if (dateA !== dateB) {
              return dateB.localeCompare(dateA);
            }
            const orderNumA = a.ordernumber || '';
            const orderNumB = b.ordernumber || '';
            return orderNumB.localeCompare(orderNumA);
          });
          // console.log(this.pendingorders);
        });
    },
    async handlePendingOrderClose() {
      this.pendingOrderPopupId = null;
      this.pendingordData = {};
      this.pendingDetails = {};
      if (this.ispendingordermodal) {
        await this.GetAccountPendingOrders();
        this.pendingorders = this.allpendingorders;
      } else {
        await this.GetAccountPendingOrders();
      }
    },
    // OrderWidget emits an event to trigger this, which is used to close the pendingorder-popup
    async handleOrderWidgetPopupClose() {
      this.orderWidgetDetailOpen = false;
      this.pendingordData = {};
      this.pendingDetails = {};
      this.orderNum = null;
      await this.GetAccountPendingOrders();
    },
    RetrieveOrder(eventdata) {
      //lets send the paramaters to showPendingOrder method and then bind order data
      this.showOrderWidgetOrder(eventdata);

      // console.log(eventdata);
      //close qmodel
    },
    // Refactored previous implementation to use the new order object structure.
    async showOrderWidgetOrder(order) {
      const o = order
      const pid = this.normalizeId(o.pid);
      const orderNum = o.orderId;
      const procType = o.procOrMed;

      if (!pid || orderNum === "") {
        console.warn("showOrderWidgetOrder: missing patient id or order number", o);
        return;
      }

      const content = {
        API_Meth: "GetOrderDetails",
        type: procType,
        id: o.procOrMedId ?? o.procormedid ?? 0,
        ordernumber: orderNum,
        patientid: pid,
      };

      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        });

        const mapped = {
          ...o,
          patientid: pid,
          pid,
          ordernumber: orderNum,
          orderId: orderNum,
          procOrMed: procType,
          orderdate: o.orderDate ?? o.orderdate ?? "",
          ordertime: o.orderTime ?? o.ordertime ?? "",
          ordertype: o.orderType ?? o.ordertype ?? "",
        };

        this.orderNum = orderNum;
        this.pendingDetails = res.data && typeof res.data === "object" ? res.data : {};
        this.pendingordData = mapped;
        this.orderWidgetDetailOpen = true;
        await this.$nextTick();
        const el = document.getElementById("pendingorder_popup_widget");
        if (el) {
          el.style.display = "block";
        }
      } catch (err) {
        console.error("showOrderWidgetOrder", err);
      }
    },
    async showPendingOrder(order, pid) {
      this.pendingOrderPopupId = null;
      this.pendingordData = {};
      this.pendingDetails = {};
      
      await this.$nextTick();
      
      if (order.med_medentryid) {
        this.pendingDetails = {
          medId: order.med_medentryid,
          medentryid: order.med_medentryid,
          medName: order.med_medname,
          medname: order.med_medname,
          dosage: order.med_amount,
          frequency: order.med_frequency,
          route: order.med_route,
          altRoute: order.med_alt_route,
          diagDescription: order.med_diagnose_code,
          startDate: order.med_startdate,
          endDate: order.med_enddate,
          unitType: order.med_doseuom,
          instructions: order.med_instruction,
          prn: order.med_prn,
        };
      }
      if (order.procOrMed === "procedure") {
        const content = {
          API_Meth: "GetOrderDetails",
          type: order.procOrMed,
          id: order.procOrMedId || 0,
          ordernumber: order.ordernumber,
          patientid: order.patientid,
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            this.pendingDetails = res.data;
          });
      }
      
      this.pendingordData = order;
      this.orderNum = order.ordernumber;
      this.ordstatus = false;
      this.pendingOrderPopupId = pid;
    },
    closePendingOrder() {
      $("#pendingorder_popup").css("display", "none");
      //now lets reset the pendingordData
      this.pendingordData = [];
      //this.togglePendingOrder=false;
    },
    async CallProvider() {
      // The call is bridged to the caller. keyon picks one of the caller's own
      // numbers on its record - this profile phone when it is one of them - and
      // says what is missing when it has none, so an empty profile phone is no
      // reason to stop here. Connecting only when keyon says Twilio took the
      // call. keyon calls only numbers on file for the account, so a number
      // typed over the prefilled one is refused, and the refusal says so
      // (src/api/smsApi.js).
      const result = await placePhoneCall($("#smsfield").val(), messagingSender(this.allData).phone);
      alert(result.ok ? "Connecting call..." : result.message);
    },
    viewPendingorders() {
      this.GetAccountPendingOrders();
    },
    SetOptionValue() {
      // console.log("Chenge Options");
      let comOption = $("#comtype").val();
      switch (comOption) {
        case "SMS": {
          this.smsOption = true;
          this.emailOption = false;
          this.callOption = false;
          break;
        }
        case "Email": {
          this.emailOption = true;
          this.smsOption = false;
          this.callOption = false;
          break;
        }
        case "Call": {
          this.callOption = true;
          this.emailOption = false;
          this.smsOption = true;
          break;
        }
        case "Internal": {
          //should be able to call a function from inside the internal messaging component
        }
        case "selected": {
          this.callOption = false;
          this.smsOption = false;
          this.emailOption = false;
          break;
        }
      }
    },
    showMsgBoard(primaryphone, licensenum, firstname, lastname, email) {
      if (this.wannMsg == true) {
        this.wannMsg = false;
      } else {
        this.wannMsg = true;
        //set  the to field
        this.nursName = firstname + " " + lastname;
        $("#tofield").val(this.nursName);
        this.nursEmail = email;
        //set the phone field so if they decide to text or call its the actual nurses information
        this.nursPhone = "";
        this.nursPhone = primaryphone;
      }
    },
    closeMsgBoard() {
      this.wannMsg = false;
    },
    SendMessages() {
      let comOption = $("#comtype").val();
      // console.log(comOption);

      switch (comOption) {
        case "SMS": {
          if (this.smsOption == true) {
            this.sendText();
          }

          break;
        }
        case "Email": {
          if (this.emailOption == true) {
            this.SendProvEmail();
          }

          break;
        }
        case "Call": {
          if (this.callOption == true) {
            this.CallProvider();
          }

          break;
        }
        case "Internal": {
          //should be able to call a function from inside the internal messaging component
        }
        case "selected": {
          alert(
            "Can't send a message before a communication type is selected. Please select a method and try again."
          );
          break;
        }
      }
    },
    async SendProvEmail() {
      let mcontent = {
        Provider: {
          API_Meth: "SendProviderEmail",
          provider: this.allData.patient.firstName + " " + this.allData.patient.lastName,
          subject: $("#subjectfield").val(),
          message: $("#msgboxfield").val(),
          toemail: $("#emailfield").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", mcontent, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          // console.log(res.data);
          // console.log(res.data.message);

          if (res.data.message && res.data.message == "EmailSent") {
            alert("Email Successfully Sent to Proviver" + " " + $("#tofield").val());
            //now hide the UI
          }
        });
    },
    async sendText() {
      // Sent only when keyon says Twilio took it. keyon texts only numbers on
      // file for the account, so a number typed over the prefilled one is
      // refused, and the refusal says so (src/api/smsApi.js).
      const result = await sendTextMessage($("#smsfield").val(), $("#msgboxfield").val());
      if (!result.ok) {
        alert(result.message);
        return;
      }
      alert("Text sent");
      // closeText() was never defined here, so a sent text used to end in a
      // TypeError with the board still open.
      this.closeMsgBoard();
    },
    showProviderCard(index, accountnumber, npinumber) {
      // console.log(npinumber);
      if (this.viewProvidercard == true) {
        this.viewProvidercard = false;
        //lets clear the array
        this.indivprovList = [];
      } else {
        this.viewProvidercard = true;

        //lets try and set another array that can pull the information and avoid making another call to the server
        for (var i = 0; i < this.providerList.length; i++) {
          if (this.providerList[i].npinumber == npinumber) {
            //set provName
            this.provName =
              this.providerList[i].firstname + " " + this.providerList[i].lastname;
            this.indivprovList.push(this.providerList[i]);

            break;
          }
        }
        //// console.log(this.indivprovList);
      }
    },
    CloseProviderCard() {
      this.viewProvidercard = false;
    },
    showAidCard(accountnumber, certificatenumber) {
      //let card = document.getElementById(`ncard${licensenum}`);
      // // console.log(card);
      if (this.viewAidcard == true) {
        this.viewAidcard = false;
      } else {
        this.viewAidcard = true;
        //now call and get the individual nurse Information
        this.getIndividaulAidCard(accountnumber, certificatenumber);
      }
    },
    showNurseCard(accountnumber, licensenum) {
      //let card = document.getElementById(`ncard${licensenum}`);
      // // console.log(card);
      if (this.viewNursecard == true) {
        this.viewNursecard = false;
      } else {
        this.viewNursecard = true;
        //now call and get the individual nurse Information
        this.getIndividaulNurseCard(accountnumber, licensenum);
      }
    },
    CloseNurseCard() {
      this.viewNursecard = false;
      this.viewAidcard = false;
    },
    showAssignments(assign) {
      if (!this.canAssignStaffToPatients) {
        alert("You do not have permission to adjust patient assignments.");
        return;
      }
      let patientList = this.patientList;
      let assignList = {};
      if (assign && Array.isArray(assign)) {
        assign.forEach((assignment) => {
          let filt = patientList.filter(
            (patient) => patient.externId == assignment.patient_id
          );
          assignList[`${filt[0].firstName} ${filt[0].lastName}`] =
            assignment.assignment_date;
        });
      }
      this.assignedPatients = assignList;
    },
    async getIndividaulAidCard(accountnumber, certificatenum) {
      let content = {
        NursyInfo: {
          API_Meth: "GetIndividualAccountAid",
          // accountnumber: this.allData.patient.externId2,
          certificatenumber: certificatenum,
          accountnumber: accountnumber,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            //let nurseList = res.data.nurseInfo;
            this.nurseLList = res.data.records;
            // console.log(this.nurseLList);
            //// console.log(this.indvidualNurse);
          }
        });
    },
    async getIndividaulNurseCard(accountnumber, licensenum) {
      let content = {
        NursyInfo: {
          API_Meth: "GetIndividualAccountNurse",
          action: "GetPatientsAssigned",
          accountnumber: this.allData.patient.externId2,
          licensenum: licensenum,
          accountnumber: accountnumber,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            //let nurseList = res.data.nurseInfo;
            this.nurseLList = res.data.records;

            // console.log(this.indvidualNurse);
          }
        });
    },
    async getAccountType(subaccnt) {
      await this.ensureGlobalRoleMembersLoaded();
      let content = {
        Account: {
          API_Meth: "GetAccountType",
          accountnumber: this.allData.patient.externId2,
          subaccountnumber: subaccnt,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(async (res) => {
          console.log("Returning Account Type Info");
          console.log(res.data);
          if (res.data) {
            this.accounttype = res.data.providerAssignment.accounttype;
            // Main's "Administrators without an NPI" gate (showOrder) read its
            // licence field, which held an Administrator's NPI. The port's
            // bridge answers the licences as records: the NPI on file and
            // nothing else, the same rule as OrdersPage and OrderPopup.
            this.profflicense = npiFromAccountType(res.data.professionalLicense);
            this.provData = res.data.professionalLicense.records[0];
            // `accounttype` is main's words (the bridge's answer, MX-14);
            // legacyAccountType leaves them as they are and reads a slug too.
            const legacyType = legacyAccountType(this.accounttype);
            if (legacyType == "Provider") {
              this.ordType = "Pending";
            } else if (legacyType == "Registered Nurse") {
              this.ordType = "Active-Pending";
            }
            await this.loadPatientsForHomeGridFromGroups();
            if (this.isStaffScopedPatientView() && !this.isOrgAdministrator) {
              await this.loadOwnPatientsMembers();
              this.applyGroupMembershipFilters();
            }
            if (this.tab === "Patient") {
              this.gridList = this.patientsGrid;
              this.paginate(1);
              this.GetAccountPendingOrders();
            }
          } else {
            this.patients = null;
          }
        });
    },
    async getAccountProviders() {
      await this.ensureGlobalRoleMembersLoaded();
      //lets set global varible for later use
      // this.accountID=this.allData.patient.externId2;
      let content = {
        Provider: {
          API_Meth: "GetAccountProviders",
          accountnumber: this.allData.patient.externId2,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            this.rawProviderList = Array.isArray(res.data.provider)
              ? res.data.provider
              : [];
            this.providerList = this.rawProviderList;
            this.applyGroupMembershipFilters();
          }
        });
    },
    // Fetch allied professionals for the account (filtered to org group members).
    async getAccountAlliedProfessionals() {
      await this.ensureGlobalRoleMembersLoaded();
      let content = {
        NursyInfo: {
          API_Meth: "GetAccountAlliedProfessionals",
          accountnumber: this.allData.patient.externId2,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data) {
            this.rawAlliedProList = Array.isArray(res.data.nurseInfo)
              ? res.data.nurseInfo
              : [];
            this.alliedProList = this.rawAlliedProList;
            this.applyGroupMembershipFilters();
          }
        });
    },
    // Fetch geriatric care managers (account_user only).
    async getAccountGeriatricCareManagers() {
      await this.ensureGlobalRoleMembersLoaded();
      let content = {
        NursyInfo: {
          API_Meth: "GetAccountGeriatricCareManagers",
          accountnumber: this.allData.patient.externId2,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data) {
            this.rawGcmList = Array.isArray(res.data.gcmInfo) ? res.data.gcmInfo : [];
            this.gcmList = this.rawGcmList;
            this.applyGroupMembershipFilters();
          }
        });
    },
    async getAccountAides() {
      await this.ensureGlobalRoleMembersLoaded();
      //lets set global varible for later use
      this.accountID = this.allData.patient.externId2;
      let content = {
        NursyInfo: {
          API_Meth: "GetAccountAids",
          action: "", //"GetPatientsAssigned",
          accountnumber: this.allData.patient.externId2,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            this.rawAidList = Array.isArray(res.data.nurseInfo)
              ? res.data.nurseInfo
              : [];
            this.homeaidList = this.rawAidList;
            this.homeaidLList = this.rawAidList;
            this.applyGroupMembershipFilters();
            //this.viewNursecard =true;
            /* nurseList.forEach((nurse) => {
              nurse["assignments"] = res.data.assignments[nurse.providerID];
            });*/
            // this.nurseList = nurseList;
            // console.log(this.homeaidList);
          }
        });
    },
    async getAccountNurses() {
      await this.ensureGlobalRoleMembersLoaded();
      //lets set global varible for later use
      this.accountID = this.allData.patient.externId2;
      let content = {
        NursyInfo: {
          API_Meth: "GetAccountNurse",
          action: "GetPatientsAssigned",
          accountnumber: this.allData.patient.externId2,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            let nurseList = res.data.nurseInfo;
            //this.nurseLList = res.data.nurseInfo;
            if (nurseList && Array.isArray(nurseList)) {
              nurseList.forEach((nurse) => {
                const nid = nurse.providerid ?? nurse.providerID ?? nurse.pmid;
                nurse["assignments"] = res.data.assignments[nid];
              });
            }
            this.rawNurseList = Array.isArray(nurseList) ? nurseList : [];
            this.nurseList = this.rawNurseList;
            this.applyGroupMembershipFilters();
            // console.log("getting NurseList");
            // console.log(this.nurseList);
          }
        });
    },
    async getProviderAccountPatients(providerRow) {
      const npi = this.normalizeId(providerRow?.npinumber);
      const providerName =
        `${providerRow?.firstname ?? ""} ${providerRow?.lastname ?? ""}`.trim();
      this.PListPatientName = providerName || null;
      this.patientasID = npi || null;
      this.idproviderID = npi || null;

      const ownerCandidates = this.staffPatientsOwnerCandidates(providerRow);
      const { ownerUniqueId, assignedSet } = await this.resolveStaffPatientsProtoGroup(ownerCandidates);
      this.idproviderUniqueID = ownerUniqueId || ownerCandidates[0] || npi || "";

      const content = {
        ProviderInfo: {
          API_Meth: "GetProviderAccountPatients",
          accountnumber: this.allData.patient.externId2,
          providerid: npi,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(async (res) => {
          const patientSource = Array.isArray(res?.data?.patientInfo) ? res.data.patientInfo : [];
          if (!patientSource.length) {
            this.pickListLoadFailureAlert("patient", res);
            this.patientPL = [[], []];
            return;
          }

          const isPatientAssigned = (p) => {
            const candidates = [
              this.normalizeId(p?.psersonalID ?? ""),
              this.normalizeId(p?.patient_id ?? ""),
              this.normalizeId(p?.pid ?? ""),
              this.normalizeId(p?.mid ?? ""),
              this.normalizeId(p?.unique_ID ?? ""),
            ].filter((x) => x.length > 0);
            return candidates.some((c) => assignedSet.has(c));
          };

          const target = patientSource.filter((p) => isPatientAssigned(p));
          const source = patientSource.filter((p) => !isPatientAssigned(p));
          this.patientPL = [source, target];
        })
        .catch((err) => {
          this.pickListRequestErrorAlert(err);
          this.patientPL = [[], []];
        });
    },
    async getAccountPatients(staffRow) {
      if (!this.canAssignStaffToPatients) {
        alert("You do not have permission to adjust patient assignments.");
        return;
      }
      const apiStaffKey = this.normalizeId(
        staffRow?.licensenum ??
          staffRow?.certificatenumber ??
          staffRow?.providerid ??
          staffRow?.providerID ??
          ""
      );
      const staffName =
        `${staffRow?.firstname ?? ""} ${staffRow?.lastname ?? ""}`.trim();
      this.PListPatientName = staffName || null;
      this.patientasID = apiStaffKey || null;

      const ownerCandidates = this.staffPatientsOwnerCandidates(staffRow);
      const { ownerUniqueId, assignedSet } = await this.resolveStaffPatientsProtoGroup(ownerCandidates);
      const resolvedOwner = ownerUniqueId || ownerCandidates[0] || apiStaffKey || "";
      if (this.tab === "Aid") {
        this.idhhaUniqueID = resolvedOwner;
        this.idnurseID = "";
        this.idnurseUniqueID = "";
        this.idAlliedProUniqueID = "";
      } else if (this.tab === "AlliedPro") {
        this.idAlliedProUniqueID = resolvedOwner;
        this.idnurseID = "";
        this.idnurseUniqueID = "";
        this.idhhaUniqueID = "";
      } else {
        this.idnurseID = apiStaffKey || "";
        this.idnurseUniqueID = resolvedOwner;
        this.idhhaUniqueID = "";
        this.idAlliedProUniqueID = "";
      }

      const content = {
        NursyInfo: {
          API_Meth: "GetAccountPatients",
          accountnumber: this.allData.patient.externId2,
          nurseid: apiStaffKey,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(async (res) => {
          const patientSource = Array.isArray(res?.data?.patientInfo) ? res.data.patientInfo : [];
          if (!patientSource.length) {
            this.pickListLoadFailureAlert("patient", res);
            this.patientPL = [[], []];
            return;
          }

          const isPatientAssigned = (p) => {
            const candidates = [
              this.normalizeId(p?.psersonalID ?? ""),
              this.normalizeId(p?.patient_id ?? ""),
              this.normalizeId(p?.pid ?? ""),
              this.normalizeId(p?.mid ?? ""),
              this.normalizeId(p?.unique_ID ?? ""),
            ].filter((x) => x.length > 0);
            return candidates.some((c) => assignedSet.has(c));
          };

          const target = patientSource.filter((p) => isPatientAssigned(p));
          const source = patientSource.filter((p) => !isPatientAssigned(p));
          this.patientPL = [source, target];
        })
        .catch((err) => {
          this.pickListRequestErrorAlert(err);
          this.patientPL = [[], []];
        });
    },
    toggleStatus(id) {
      if (this.filtered) return;
      if (_.includes(this.filterList, id)) {
        let fi = _.indexOf(this.filterList, id);
        this.$delete(this.filterList, fi);
      } else {
        this.filterList.push(id);
      }
      this.preferences.provider_filter = this.filterList;
      updatePreferences(this.preferences);
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    async showNote(id, email, index, user = null) {
      if (user && this.isPatientPending(user)) return;
      if (!this.canWriteNotes) {
        alert("You do not have permission to write notes");
        return;
      }

      if (this.activeNotePopupId === id) {
        this.activeNotePopupId = null;
        return;
      }

      this.activeOrderPopupId = null;

      this.patientEmail = email;
      let date = new Date();
      let tmpTime = date.toLocaleTimeString("en-US", { hour12: false }).slice(0, -3);
      this.noteTime = tmpTime.length == 7 ? `0${tmpTime}` : tmpTime;

      this.activeNotePopupId = null;
      await this.$nextTick();
      this.activeNotePopupId = id;
    },

    async loadProviders() {
      let content = {
        NursyInfo: {
          API_Meth: "GetAccountNurse",
          accountnumber: this.allData.patient.externId2,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            this.allProvs = res.data.nurseInfo;
          } else {
            this.allProvs = null;
          }
        });
    },
    movingToPatientPool(event) {
      // console.log(event);

      // console.log(this.patientPL);
      let targetSourceItems = event.items;
      let insourcepmid = "";
      let patientname = "";
      const patientDisplayName = (p) =>
        `${p?.first_name ?? p?.firstname ?? ""} ${p?.lastname ?? ""}`.trim();
      for (var i = 0; i < event.items.length; i++) {
        patientname = patientDisplayName(targetSourceItems[i]);
        insourcepmid = targetSourceItems[i].pid;
      }
      if (this.patientPL[0].length > 0) {
        //filter the nursesPL

        for (var p = 0; p < this.patientPL[0].length; p++) {
          if (
            patientDisplayName(this.patientPL[0][p]) === patientname &&
            this.patientPL[0][p].pid == insourcepmid
          ) {
            // alert("Remove this one"+nursename);
            this.patientPL[0].splice(p, 1);
          }
        }
        //// console.log(this.nursesPL[0].filter((value,index) => this.nursesPL[0].indexOf(value) ==index));
        this.patientPL[0].filter(
          (value, index) => this.patientPL[0].indexOf(value) == index
        );

        //now loop through nursesPL and remove the item that matches nursename

        // console.log(insourcepmid);
        // console.log(nursename);
      }
    },
    movingToNursePool(event) {
      // console.log(event);

      // console.log(this.nursesPL);
      let targetSourceItems = event.items;
      let insourcepmid = "";
      let nursename = "";
      for (var i = 0; i < event.items.length; i++) {
        nursename = targetSourceItems[i].firstname + " " + targetSourceItems[i].lastname;
        insourcepmid = targetSourceItems[i].pmid;
      }
      if (this.nursesPL[0].length > 0) {
        //filter the nursesPL

        for (var p = 0; p < this.nursesPL[0].length; p++) {
          if (
            this.nursesPL[0][p].firstname + " " + this.nursesPL[0][p].lastname ==
              nursename &&
            this.nursesPL[0][p].pmid == insourcepmid
          ) {
            // alert("Remove this one"+nursename);
            this.nursesPL[0].splice(p, 1);
          }
        }
        //// console.log(this.nursesPL[0].filter((value,index) => this.nursesPL[0].indexOf(value) ==index));
        this.nursesPL[0].filter(
          (value, index) => this.nursesPL[0].indexOf(value) == index
        );

        //now loop through nursesPL and remove the item that matches nursename

        // console.log(insourcepmid);
        // console.log(nursename);
      }
    },
    async showOrder(id, user = null) {
      const row = user || this.findPatientRowById(id);
      if (row && this.isPatientPending(row)) return;
      if (!this.canOrderWrite) {
        alert("You do not have permission to write orders");
        return;
      }
      //second Administrator Check
     
      // Main's words against the bridge's slug (utils/accountTypeLabel.js),
      // and the NPI on file as `profflicense` (getAccountType), as OrdersPage.
      if(legacyAccountType(this.accounttype) === "Administrator" && this.profflicense ==="")
      {
        alert("Sorry, Administrators without an NPI can't write or assign Orders. Please ask the administrator to upgrade your permissions");
        return;
      }

      if (this.activeOrderPopupId === id) {
        this.activeOrderPopupId = null;
        return;
      }

      this.activeNotePopupId = null;

      this.activeOrderPopupId = null;
      await this.$nextTick();
      this.activeOrderPopupId = id;
      
      let content = {
        systemData: {
          API_Meth: "GetOrderNumber",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let num = res.data.ordernumber;
          if (num && num != "") {
            this.newOrderNum = num;
          } else
            alert(
              "Error generating order number. Contact an administrator before creating a new order."
            );
        });
    },
    handleOrderPopupClose() {
      // Reset activeOrderPopupId when order popup is closed
      this.activeOrderPopupId = null;
    },
    async showNurseModule(id, id2, patientName, user = null) {
      if (user && this.isPatientPending(user)) return;
      if (!this.canAssignStaffToPatients) {
        alert("You do not have permission to adjust patient assignments.");
        return;
      }
      // console.log(this.allData.patient);
      // console.log(id); //unique IDentifer
      // console.log(id2); //account number
      //set Pateint Name
      this.PListPatientName = patientName;
      this.assignmentId = id;
      this.patId = id;
      this.accountId = id2;
      let content = {
        NursyInfo: {
          API_Meth: "GetAccountNurse",
          action: "GetNursesAssigned",
          patientid: id,
          accountnumber: id2, //this.allData.patient.externId2
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(async (res) => {
          const data = res?.data || {};
          const status = String(data.status || "").toLowerCase();
          // Only alert on real failures — an empty nurse roster is a valid response.
          if (status === "error" || (data.error && !Array.isArray(data.nurseInfo))) {
            this.pickListLoadFailureAlert("nurse", res);
            this.nursesPL = [[], []];
            return;
          }

          // Retrieves the nurse information from the response
          const nurseSource = Array.isArray(data.nurseInfo) ? data.nurseInfo : [];
          this.nurses = nurseSource;

          // Override picklist target using current group membership (prevents accidental overwrites).
          const assignedSet = await this.loadOwnedGroupMemberIds(id, ["nurses", "nurse"]);
          const isNurseAssigned = (n) => {
            const candidates = [
              this.normalizeId(n?.pmid ?? ""),
              this.normalizeId(n?.providerID ?? ""),
              this.normalizeId(n?.unique_ID ?? ""),
              this.normalizeId(n?.pid ?? ""),
            ].filter((x) => x.length > 0);
            return candidates.some((c) => assignedSet.has(c));
          };

          const target = nurseSource.filter((n) => isNurseAssigned(n));
          const source = nurseSource.filter((n) => !isNurseAssigned(n));
          this.nursesPL = [source, target];
        })
        .catch((err) => {
          this.pickListRequestErrorAlert(err);
          this.nursesPL = [[], []];
        });
    },
    //try to get nursePL second array items to find the id of the undefined
    findPickListID(name) {
      // console.log("Inside the find PickListID section");
      let spltname = name.split(" ");
      // console.log(spltname);
      let fname = spltname[0];
      let lname = spltname[1];
      let nwar = this.nursesPL[1];
      let providerID = null;
      for (let t = 0; t < nwar.length; t++) {
        let constructname = fname + " " + lname;
        if (constructname == nwar[t].firstname + " " + nwar[t].lastname) {
          //lets get the id
          providerID = nwar[t].pmid;
          return providerID;
        }
      }
    },
    closePatientAssigned() {
      this.patientasID = null;
      this.idnurseID = "";
      this.idnurseUniqueID = "";
      this.idhhaUniqueID = "";
      this.idAlliedProUniqueID = "";
    },
    // PickList save for allied pro assignments (group-based dual-write).
    async saveAlliedProPatientAssigned(e, selectAr) {
      e.preventDefault();
      const patient_unique_IDs = (Array.isArray(selectAr) ? selectAr : [])
        .map((p) =>
          this.normalizeId(
            p?.psersonalID ?? p?.patient_id ?? p?.pid ?? p?.unique_ID ?? ""
          )
        )
        .filter((x) => x.length > 0);

      const content = {
        Groups: {
          API_Meth: "SetPatientsForAlliedProfessional_GroupBased",
          accountnumber: this.allData.patient.externId2,
          allied_professional_unique_ID: this.idAlliedProUniqueID,
          patient_unique_IDs,
          actor_unique_ID: this.actorUniqueId,
        },
      };

      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        });
        const status = res?.data?.status;
        if (status !== "Successful") {
          alert(res?.data?.message || "Unable to save allied professional patient assignments.");
        }
      } catch (err) {
        console.error("Allied professional assignment failed:", err);
        alert("Unable to save allied professional patient assignments.");
      } finally {
        this.closePatientAssigned();
      }
    },
    closeNurseAssigned() {
      this.assignmentId = null;
    },
    //Provider Assign Function (dual-write via groups)
    async saveProviderAssigned(e, selectAr) {
      e.preventDefault();
      this.accountId = this.allData.patient.externId2;

      const patient_unique_IDs = (Array.isArray(selectAr) ? selectAr : [])
        .map((p) =>
          this.normalizeId(
            p?.psersonalID ?? p?.patient_id ?? p?.pid ?? p?.unique_ID ?? ""
          )
        )
        .filter((x) => x.length > 0);

      const content = {
        Groups: {
          API_Meth: "SetPatientsForProvider_GroupBased",
          accountnumber: this.accountId,
          provider_unique_ID: this.idproviderUniqueID,
          patient_unique_IDs,
          actor_unique_ID: this.actorUniqueId,
        },
      };

      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });

      if (res?.data?.status && String(res.data.status).toLowerCase().includes("successful")) {
        alert("Assignments Updated Successfully");//trying to give the user an alert. Was orignally there but original code has been refactored.
        this.closePatientAssigned();
      }
    },
    //patientAssign function (dual-write via groups)
    async savePatientAssigned(e, selectAr) {
      e.preventDefault();
      this.accountId = this.allData.patient.externId2;

      const patient_unique_IDs = (Array.isArray(selectAr) ? selectAr : [])
        .map((p) =>
          this.normalizeId(
            p?.psersonalID ?? p?.patient_id ?? p?.pid ?? p?.unique_ID ?? ""
          )
        )
        .filter((x) => x.length > 0);

      const content = {
        Groups: {
          API_Meth: "SetPatientsForNurse_GroupBased",
          accountnumber: this.accountId,
          nurse_unique_ID: this.idnurseUniqueID,
          patient_unique_IDs,
          actor_unique_ID: this.actorUniqueId,
        },
      };

      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });

      if (res?.data?.status && String(res.data.status).toLowerCase().includes("successful")) {
        alert("Assignments Updated Successfully");//trying to give the user an alert. Was orignally there but original code has been refactored.
        this.closePatientAssigned();
      }
    },
    async saveAidPatientAssigned(e, selectAr) {
      e.preventDefault();
      this.accountId = this.allData.patient.externId2;

      const patient_unique_IDs = (Array.isArray(selectAr) ? selectAr : [])
        .map((p) =>
          this.normalizeId(
            p?.psersonalID ?? p?.patient_id ?? p?.pid ?? p?.unique_ID ?? ""
          )
        )
        .filter((x) => x.length > 0);

      const content = {
        Groups: {
          API_Meth: "SetPatientsForHomeHealthAids_GroupBased",
          accountnumber: this.accountId,
          hha_unique_ID: this.idhhaUniqueID,
          patient_unique_IDs,
          actor_unique_ID: this.actorUniqueId,
        },
      };

      const res = await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      });

      if (res?.data?.status && String(res.data.status).toLowerCase().includes("successful")) {
        alert("Assignments Updated Successfully");//trying to give the user an alert. Was orignally there but original code has been refactored.
        this.closePatientAssigned();
      }
    },
    saveNurseAssigned(e, selectAr) {
      // dual-write via groups
      e.preventDefault();
      const nurse_unique_IDs = (Array.isArray(selectAr) ? selectAr : [])
        .map((n) =>
          this.normalizeId(
            n?.pmid ?? n?.providerID ?? n?.unique_ID ?? n?.pid ?? ""
          )
        )
        .filter((x) => x.length > 0);

      const content = {
        Groups: {
          API_Meth: "SetNursesForPatient_GroupBased",
          accountnumber: this.accountId,
          patient_unique_ID: this.patId,
          nurse_unique_IDs,
          actor_unique_ID: this.actorUniqueId,
        },
      };

      return axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (
            res?.data?.status &&
            String(res.data.status).toLowerCase().includes("successful")
          ) {
            alert("Assignments Updated Successfully");//trying to give the user an alert. Was orignally there but original code has been refactored. 
            this.closeNurseAssigned();
          }
        });
    },
    async AssignPatientsToProvider(patientAr, provID, accntid) {
      alert("Saving Patients to Provider");
      let providerID = provID;
      let acntID = accntid;
      let content = {
        ProviderInfo: {
          API_Meth: "AssignPatientToProvider",
          providerid: providerID,
          accountnumber: acntID,
          patientInfo: patientAr,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          let message = res.data.message;
          if (message == "Patient Assigned Successfully") {
            //lets check to see if they were assigned and/or discharged
            let msg = "Patient(s):";
            if (res.data.patientInfo.length > 0) {
              for (var t = 0; t < res.data.patientInfo.length; t++) {
                msg += " " + res.data.patientInfo[t] + ", ";
              }
              msg += "were assigned to the nurse successfully!";
              alert(msg);
            } else if (res.data.dischargeInfo.length > 0) {
              msg += " THe following Patients(s) were discharged from the nurse:";
              for (var j = 0; j < res.data.dischargeInfo.length; j++) {
                // console.log(res.data.dischargeInfo[j]);
                msg += " " + res.data.dischargeInfo[j] + ", ";
              }
              msg += "/n Thank You.";
              alert(msg);
            } else {
              alert("Data was updated, but please verify for your records");
            }
          } else if (message == "Patient(s) Already Assigned") {
            alert("Patient(s) Already Assigned to the Nurse");
          } else {
            alert(
              "Patient Not Assigned Successfully,Please try again or contact your system Administrator"
            );
          }
          if (message == "Patient Assigned Successfully") {
            this.closePatientAssigned();
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    async AssignPatients(patientAr, nurseid, accntid) {
      alert("Saving Patients");
      let nurseID = nurseid;
      let acntID = accntid;
      let content = {
        NursyInfo: {
          API_Meth: "AssignPatientToNurse",
          nurseid: nurseID,
          accountnumber: acntID,
          patientInfo: patientAr,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          let message = res.data.message;
          if (message == "Patient Assigned Successfully") {
            //lets check to see if they were assigned and/or discharged
            let msg = "Patient(s):";
            if (res.data.patientInfo.length > 0) {
              for (var t = 0; t < res.data.patientInfo.length; t++) {
                msg += " " + res.data.patientInfo[t] + ", ";
              }
              msg += "were assigned to the nurse successfully!";
              alert(msg);
            } else if (res.data.dischargeInfo.length > 0) {
              msg += " THe following Patients(s) were discharged from the nurse:";
              for (var j = 0; j < res.data.dischargeInfo.length; j++) {
                // console.log(res.data.dischargeInfo[j]);
                msg += " " + res.data.dischargeInfo[j] + ", ";
              }
              msg += "/n Thank You.";
              alert(msg);
            } else {
              alert("Data was updated, but please verify for your records");
            }
          } else if (message == "Patient(s) Already Assigned") {
            alert("Patient(s) Already Assigned to the Nurse");
          } else {
            alert(
              "Patient Not Assigned Successfully,Please try again or contact your system Administrator"
            );
          }
          if (message == "Patient Assigned Successfully") {
            this.closePatientAssigned();
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    async AssignNurses(nurseAr, pid, accntid) {
      let patientID = pid;
      let acntID = accntid;
      let content = {
        NursyInfo: {
          API_Meth: "AssigNurseToPatient",
          patientid: patientID,
          accountnumber: acntID,
          nurseInfo: nurseAr,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          let message = res.data.message;
          if (message == "Nurse Assigned Successfully") {
            //lets check to see if they were assigned and/or discharged
            let msg = "Nurse(s):";
            if (res.data.nurseInfo.length > 0) {
              for (var t = 0; t < res.data.nurseInfo.length; t++) {
                msg += " " + res.data.nurseInfo[t] + ", ";
              }
              msg += "were assigned to the patient successfully!";
              alert(msg);
            } else if (res.data.dischargeInfo.length > 0) {
              msg += " THe following Nurse(s) were discharged from the patient:";
              for (var j = 0; j < res.data.dischargeInfo.length; j++) {
                // console.log(res.data.dischargeInfo[j]);
                msg += " " + res.data.dischargeInfo[j] + ", ";
              }
              msg += "/n Thank You.";
              alert(msg);
            } else {
              alert("Data was updated, but please verify for your records");
            }
            this.closeNurseAssigned();
          } else if (message == "Nurse(s) Already Assigned") {
            alert("Nurse(s) Already Assigned to the Patient");
          } else {
            alert(
              "Nurse Not Assigned Successfully,Please try again or contact your system Administrator"
            );
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    pageFactory(page, totalPages) {
      // console.log("pageFactatory page=" + page + ",totalPages=" + totalPages);
      const pagination = {};
      pagination.from = this.itemsPerPage * (page - 1) + 1;
      pagination.to = Math.min(this.gridList.length, this.itemsPerPage * page);
      pagination.currentPage = page;
      pagination.total = this.gridList.length;
      pagination.totalPage = totalPages;

      if (this.$refs["pagination-info"]) {
        this.$refs["pagination-info"].setPaginationData(pagination);
      }
      if (this.$refs["pagination"]) {
        this.$refs["pagination"].setPaginationData(pagination);
      }
    },
    paginate(curPage) {
      // let realList = this.tab == "Patient" ? this.patientList : this.gridList;
      // let realList = this.gridList
      let realList = [...this.gridList].sort((a, b) => {
        const lastNameA = (a.lastname || "").toLowerCase();
        const lastNameB = (b.lastname || "").toLowerCase();
        const firstNameA = (a.first_name || "").toLowerCase();
        const firstNameB = (b.first_name || "").toLowerCase();

        if (lastNameA < lastNameB) return -1;
        if (lastNameA > lastNameB) return 1;
        if (firstNameA < firstNameB) return -1;
        if (firstNameA > firstNameB) return 1;
        return 0;
      });
      if (realList.length === 0) {
        // this.$set(this, "patients", []);
        this["gridListPage"] = [];
        if (this.$refs["pagination-info"])
          this.$refs["pagination-info"].setPaginationData(null);
        if (this.$refs["pagination"]) this.$refs["pagination"].setPaginationData(null);
        return;
      }
      let tot = Math.ceil((realList || []).length / this.itemsPerPage);
      if (curPage < tot) {
        // this.$set(
        //   this,
        //   "patients",
        //   realList.slice(this.itemsPerPage * (curPage - 1), this.itemsPerPage * curPage)
        // );
        this["gridListPage"] = realList.slice(
          this.itemsPerPage * (curPage - 1),
          this.itemsPerPage * curPage
        );
        // this.patients = this.patientList.slice(this.itemsPerPage * (curPage - 1), this.itemsPerPage * curPage)
        this.pageFactory(curPage, tot);
      }
      if (curPage == tot) {
        // this.$set(this, "patients", realList.slice(this.itemsPerPage * (curPage - 1)));
        this["gridListPage"] = realList.slice(this.itemsPerPage * (curPage - 1));
        // this.patients = this.patientList.slice(this.itemsPerPage * (curPage - 1))
        this.pageFactory(curPage, tot);
      }

      // Keep pending orders constrained to what is currently visible in the grid page.
      if (this.tab == "Patient" && this.accounttype) {
        this.GetAccountPendingOrders();
      }
    },
    async getPatientById(id, user = null) {
      if (user && this.isPatientPending(user)) return;
      if (!this.canViewPatientCharts) return;
      console.log("Keyon Test ID " + id);
      try {
        let loader = this.$loading.show(
          {},
          { after: () => h("div", {}, "Entering patient's chart...") }
        );
        id = parseInt(id);
        await enterPatientChartAndRefresh(id);
        // After successfully entering the patient chart and refreshing data, navigate to welcome
        router.push("/welcome").catch(() => {});
        loader.hide();
      } catch (e) {
        console.error("Patient chart viewing error:", e);
        setTimeout(() => {
          router.push("/login").catch(() => {});
        }, 3000);
      }
    },
    // getPatientById(id) {
    //   console.log("Keyon Test ID " + id);
    //   try {
    //     let loader = this.$loading.show(
    //       {},
    //       {
    //         after: () => h("div", {}, "Switching accounts...")
    //       }
    //     );
    //     id = parseInt(id);
    //     enterPatientChart(id)
    //       .then(() => {
    //         window.location.hash = "null";
    //         window.location.reload();
    //       })
    //       .catch((e) => {
    //         console.log(e);
    //         setTimeout(() => {
    //           window.location.reload();
    //         }, 3000);
    //       });
    //   } catch (e) {
    //     console.log(e);
    //     setTimeout(() => {
    //       window.location.reload();
    //     }, 3000);
    //   }
    // },
    showUserForm() {
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.CREATE_ACCOUNTS,
          "You do not have permission to create accounts."
        )
      ) {
        return;
      }
      this.showingAddUser = true;
    },
    CloseaddNurse() {
      this.showingAddUser = false;
    },
  },
};
</script>

<style scoped>
#pendingorder_popup_widget {
  /* Stacking handled on .msorderwrapper in PendingOrderPopup (above eh-popup list). */
  z-index: 2000050;
}

.assignments-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
}

.patient-status-link {
  background: none;
  border: none;
  padding: 0;
  color: #0060ff;
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
}

.patient-status-link:hover {
  color: #004ecc;
}

.patient-invite-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  padding: 1rem;
}

.patient-invite-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
  padding: 1.5rem 1.75rem;
  max-width: 420px;
  width: 100%;
}

.patient-invite-modal__title {
  margin: 0 0 1rem;
  font-size: 1.15rem;
  font-weight: 600;
  color: #333;
}

.patient-invite-modal__name {
  margin: 0 0 0.35rem;
  font-weight: 600;
  color: #222;
}

.patient-invite-modal__email {
  margin: 0 0 1.25rem;
  color: #555;
  word-break: break-word;
}

.patient-invite-modal__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}

.assignments-modal {
  margin-left: auto;
  margin-right: auto;
  top: 40% !important;
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.assignedPatientName {
  float: left;
}

.assignedPatientDate {
  float: right;
}

.assignments-list {
  margin-bottom: 5%;
}

.result-item {
  display: none;
  width: 100%;
}

.nurse-card {
  display: block;
  position: absolute;
  width: 900px;
  top: 220px;
  left: 420px;
  height: auto;
  background-color: white;
  border-style: solid;
  border-color: black;
  border-width: 1px;
}
.card-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  background-color: #91c1de;
  color: #ffffff;
}
.elipse span {
  font-size: 22px;
  margin-right: 20px;
}
.control-elipse {
  text-align: center;
}
.elipse ul {
  display: none;
}
.card-controls {
  display: flex;
  flex-direction: row-reverse;
  padding-right: 40px;
}
.card-controls span {
  font-size: 22px;
  text-decoration: underline;

  text-decoration-color: orange;
}
.coltext.msgiconbtn {
  text-decoration: underline;

  text-decoration-color: #3e3d3c;
}

/* Small gap between note / order / assignment icons in the same cell */
.msgiconbtn + .ordericonbtn,
.ordericonbtn + .ordericonbtn,
.msgiconbtn + .msgiconbtn,
.ordericonbtn + .msgiconbtn {
  margin-left: 0.4rem;
}
.combox-parent {
  position: absolute;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  max-width: 650px;
  padding: 20px;
  height: auto;
  padding-bottom: 10px;
  top: 290px;
  left: 600px;
}
.mbox-verticleflex {
  display: flex;
  flex-direction: column-reverse;
}
#msgform {
  width: 100%;
  height: auto;
}
.field-items {
  display: flex;
}
.field-items label {
  margin-right: 15px;
  margin-bottom: 15px;
}
.field-items input[type="text"] {
  border-bottom-style: solid;
  border-right-style: none;
  border-left-style: none;
  border-top-style: none;
  border-color: #000;
  margin-bottom: 10px;
}
#msgboxfield {
  width: 100%;
  height: 145px;
}
.btndiv {
  display: flex;
  margin-top: 12px;
}
.btndiv button {
  margin-right: 12px;
}
/*.gridarea .table-container{
  position:absolute;
  width:900px;
  background-color:#ffffff;
  border-color:#000000;
  border-style:solid;
  border-width:1px;
  top:290px;
  left:384px;
  height:auto;
}*/
.provTitle {
  position: absolute;
  width: 900px;
  border-color: #000;
  border-style: solid;
  background-color: #34638a;
  color: #ffffff;
  font-weight: 600;
  top: 232px;
  left: 384px;
}
#pdorders {
  background-color: #ff0000;
  color: #ffffff;
  font-weight: 600;
  padding: 2px;
  width: 42px;
  display: inline-block;
  margin-top: 5px;
  border-radius: 9px;
}
.ordqmodaltitlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  /* Match .welcome-ds .ordqmodaltitlebar (lost when Teleport leaves welcome-ds). */
  background-color: var(--eh-teal-ink, #24555b);
  color: var(--eh-on-dark, #ffffff);
  padding: 0;
}
.ordqmodaltitlebar h1 {
  margin: 0;
  flex: 1;
  text-align: center;
  font-size: 22px;
  font-family: var(--eh-font-header, inherit);
  font-weight: 600;
  color: var(--eh-on-dark, #ffffff);
  padding: 10px 0;
}
.ordq-close {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: var(--eh-on-dark, #ffffff);
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 16px;
}
.ordq-close:hover {
  opacity: 0.85;
}
.ordqmodalbody {
  padding: 10px;
}
.ordqmodalbody p {
  font-family: "Open Sans";
  font-size: 19px;
}
.ordqmodalbody p a {
  text-decoration: underline;
  text-decoration-color: bisque;
  font-weight: 600;
  color: var(--eh-teal, #4b9ca5);
  cursor: pointer;
}
.orderquestmodal-overlay {
  /* Backdrop + z-index from brand-ds (.eh-popup-overlay) — centers the dialog. */
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.orderquestmodal {
  /* Original size/surface; shared border token for the opt-in popup chrome. */
  width: min(872px, 92vw);
  background-color: whitesmoke;
  border: var(--eh-popup-border, 3px solid #000000);
  border-radius: 9px;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ordgridtitlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 14px 16px;
  border-bottom: 1px solid var(--eh-divider, #e2e8f0);
  background: transparent;
  color: var(--eh-teal-ink, #24555b);
}
.ordgridtitlebar-spacer {
  width: 28px;
  flex-shrink: 0;
}
.ordgridtitle {
  flex: 1;
  margin: 0;
  text-align: center;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--eh-teal-ink, #24555b);
}
.ordgrid-close {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--eh-teal-deep, #2f6f76);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  border-radius: 6px;
  padding: 0;
}
.ordgrid-close:hover {
  background: var(--eh-teal-wash, #dceeef);
  color: var(--eh-teal-ink, #24555b);
}
.ordgridtitlebar p {
  font-size: 19px;
  padding: 10px 0px;
}
.ordpendingridbody {
  width: 100%;
  height: auto;
  background-color: #f3f0f0;
}
.ordgridmodal-overlay {
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.ordgridmodal {
  /* Surface, border, radius from brand-ds (.eh-popup-panel / --eh-popup-*). */
  height: auto;
  max-height: 70vh;
  padding-bottom: 40px;
  width: min(87%, 95vw);
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.ordgridmodal .gridarea {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ordgridmodal .gridarea .container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.ordgridmodal .columntop {
  height: 40px;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.pending-orders-header {
  background-color: #4887d1;
}

.pending-orders-header,
.pending-orders-row {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
}

.pending-col {
  flex: 1 1 0;
  min-width: 0;
  padding: 0 5px;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pending-col .coltext {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.pending-col-medproc {
  flex: 2 1 0;
}

.pending-col-signature {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.pending-sign-btn {
  appearance: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 4px;
  background-color: #4887d1;
  color: #fff;
  line-height: 1.2;
}

.pending-sign-btn:hover {
  background-color: #3a6faf;
}

.pending-sign-btn:focus-visible {
  outline: 2px solid #1a3d66;
  outline-offset: 2px;
}

.ordpendingridbody {
  display: flex;
  flex-direction: column;
  width: 100%;
  clear: both;
  padding: 10px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}
.ordpendingridbody .columnrow {
  width: 100%;
  margin-bottom: 8px;
  height: 32px;
  display: flex;
  flex-wrap: nowrap;
}
.ordpendingridbody .columnrow:nth-child(even) > .top-row {
  background-color: #abc9fb;
}
.ordpendingridbody .columnrow:nth-child(odd) > .top-row {
  background-color: #ffffff;
}

.pending-orders-row .top-row {
  height: 32px;
  display: flex;
  align-items: center;
}
.patient-chart-btn {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
  padding: 2px 4px;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: left;
  transition: color 0.2s ease;
  position: relative;
  z-index: 10;
  display: inline-block;
}

.patient-chart-btn:hover {
  color: #0056b3;
  text-decoration: underline;
  background-color: rgba(0, 123, 255, 0.1);
}

.patient-chart-btn:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

.patient-chart-btn--disabled {
  color: inherit !important;
  cursor: default !important;
  text-decoration: none !important;
}

.patient-chart-btn--disabled:hover {
  color: inherit !important;
  background-color: transparent !important;
  text-decoration: none !important;
}

.msgiconbtn--disabled,
.ordericonbtn--disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.msgiconbtn--disabled img,
.ordericonbtn--disabled img {
  pointer-events: none;
}

.mobile-icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.patient-name-container,
.patient-id-container {
  position: relative;
  z-index: 0;
}

@media only screen and (min-width: 577px) {
  #patientExtern,
  #patientName {
    color: blue;
    cursor: pointer;
    text-decoration: underline;
  }
}

@media only screen and (max-width: 576px) {
  .mobile-form-list {
    display: flex;
    flex-direction: column;
    border-radius: 0;
    margin-top: 0;
  }
  .mobile-list-empty {
    padding: 1.5rem 1rem;
    text-align: center;
    font-size: 0.95rem;
    font-weight: 500;
  }
  .mobile-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    margin: 0;
    border-bottom: 1px solid;
  }
  
  .patient-chart-btn {
    text-decoration: underline;
    cursor: pointer;
    background: none;
    border: none;
    padding: 2px 4px;
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    text-align: left;
    z-index: 15;
    position: relative;
  }
  .mobile-list-icons {
    display: flex;
    gap: 14px;
  }

  .mobile-icon-btn {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }

  .mobile-icon-btn i {
    pointer-events: none;
  }
}

/* Mobile-specific z-index adjustments for mobile message widget */
@media (max-width: 768px) {
  #pendingorder_popup_widget {
    z-index: 1 !important;
  }
  
  .assignments-container {
    z-index: 1 !important;
  }
  
  .nurse-card {
    z-index: 1 !important;
  }
  
  /* Ensure all high z-index elements stay below mobile widget */
  [style*="z-index"] {
    z-index: 1 !important;
  }
}

.gridarea {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
}

.grid-list-empty {
  width: 100%;
  padding: 2rem 1rem;
  text-align: center;
  color: #4a5568;
  font-size: 1rem;
  font-weight: 500;
  background-color: #fff;
  border-bottom: 1px solid #dde2e6;
}

.columntop {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  background-color: #24555b !important;
}

/* Header cells: beat keyon.scss light-blue (.container .top-col / #98bfe1) */
.columntop .top-col,
.top-col {
  background: #24555b !important;
  background-color: #24555b !important;
  color: #fff !important;
}

.columntop .coltext {
  color: #fff !important;
}

.columnrowpc {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.gridarea .columntop,
.gridarea .columnrowpc {
  width: 100%;
  max-width: 100%;
}

.id-col {
  padding-left: 15px;
}
</style>
